    <template>
      <div class="dialog-container" @click="repeatVisitInfo.remarkInfo.showRemark = false">
        <custom-dialog width="70%" :showClose="true" v-if="visibleObj.additionalPrescriptionDialog"
          :visible="visibleObj.additionalPrescriptionDialog" @close="dialogVisible('additionalPrescriptionDialog')">
          <div slot="content" v-loading="loading">
            <div class="content">
              <div class="content-left" v-loading="uploading">
                <div class="setup-warp" v-if="imgLsit.length > 0">
                    <div class="flex align-i-c">
                      <div v-if="continueDoseNum" class="mr10">续方剂量：{{ continueDoseNum }}剂</div>
                      <div>药品类型：{{recipeContinueObj.drugType == '2' ? '免煎颗粒' : '中药饮片'}}</div>
                    </div>
                    <div class="flex align-i-c">
                      <div class="setup-action" @click="handleSwitch('left')"><</div>
                      <div class="pl10 pr10">{{ computedImgIndex + 1 }}/{{ imgLsit.length }}</div>
                      <div class="setup-action" @click="handleSwitch('right')">></div>
                    </div>
                </div>
                <div v-if="imgLsit.length>0" class="img-warp">
                    <div class="img-box">
                      <el-image fit="cover" :style="`transform: rotate(${deg}deg)`" :src="url" :preview-src-list="imgLsit" />
                    </div>
                    <div class="action-warp">
                      <span @click=" deg -= 90"  class="action-icon el-icon-refresh-left"></span> 
                      <span @click=" deg += 90" class="action-icon el-icon-refresh-right"></span> 
                      <span v-if="orderInfo.orderType!='13'" @click="handleDelImg" class="action-icon el-icon-delete"></span> 
                    </div>
                </div>
                <div class="tac mt16" v-if="imgLsit.length>0">
                  <el-button @click="uploadShow = true">上传图片</el-button>
                </div>
                <div v-if="imgLsit.length==0" class="upload-warp">
                  <img :src="imgArr.uploadImg" class="uploadImg">
                  <el-button @click="uploadShow = true">上传图片</el-button>
                </div>
              </div>
              <div class="content-right">
                <div>
                  <div class="right-main" ref="rightMain">
                    <div class="right-title"></div>
                    <div class="form mt12">
                      <div class="title">病历</div>
                      <div class="form-item">
                        <div class="item-label"><span class="colorF54A">*</span> 主诉：</div>
                        <div class="flex1">
                          <el-input type="textarea" autosize v-model.trim="caseForm.patientTell"></el-input>
                        </div>
                      </div>
                      <div class="form-item">
                        <div class="item-label"> &nbsp; 辨证：</div>
                        <div class="flex1">
                          <el-input type="textarea" autosize v-model.trim="caseForm.dialectical"></el-input>
                        </div>
                      </div>
                      <div class="form-item">
                        <div class="item-label"><span class="colorF54A">*</span> 诊断：</div>
                        <div class="flex1">
                          <el-select ref="diagnoseSelect" v-model="diagnosIds" style="width: 100%;" placeholder=""
                            allow-create default-first-option filterable remote multiple reserve-keyword
                            :remote-method="meetDiagnose" @change="diagnosChange" value-key="name">
                            <el-option v-for="(item, index) in diagnosisList" class="option-item" :key="index"
                              :label="item.name" :value="item">
                              <div class="diagnose-warp">
                                <div class="flex-sh"> {{ item.name }}</div>
                                <div class="size12 color667 w220 flex">
                                  <div class="mr16 w60">{{ computeYbScope(item.ybScope)}}</div>
                                  <div class="diagnose-recode">{{ item.recode }}</div>
                                  <div class="diagnose-code">{{ item.code }}</div>
                                </div>
                              </div>
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>
                    <div class="form  mt12">
                      <div class="title">
                        <div>处方项目</div>
                        <div>
                          <custom-button size="mini" type="info" @click="addDrug">中药处方</custom-button>
                          <custom-button size="mini" @click="addChineseMedicine">中成药处方</custom-button>
                          <custom-button size="mini" type="info" @click="addPhysio">理疗处方</custom-button>
                          <custom-button size="mini" type="info" @click="openComboTemplateDialog">医联产品</custom-button>
                          <custom-button size="mini" type="info" @click="openPrescriptionTemplateDialog">处方模版</custom-button>
                          <custom-button size="mini" type="info" icon="el-icon-present" @click="openComboSelect">活动</custom-button>
                        </div>
                      </div>
                      <!-- 中药处方 -->
                      <div v-for="(item, index) in recipesList" :key="index + 'a'">
                        <div class="project"
                          v-if="item.recipeType == '1' && item.recipeSourceType != '0' && item.isYlcp == '0'">
                          <!-- <div class="project" v-for="(item, index) in computedRecipes('1')" :key="index"> -->
                          <div class="project-title">
                            <div class="display-f align-i-c">
                              <img :src="imgArr.drugIcon" class="title-icon">
                              <div>中药处方</div>
                              <div class="drug-type">
                                <div>类型：</div>
                                <el-select :ref="'typeSelect' + index" class="type-select" v-model="item.doseType"
                                  placeholder="" @change="typeChange($event, item, index)">
                                  <el-option v-for="obj in recipeList" :key="obj.value" :label="obj.label"
                                    :value="obj.value">
                                  </el-option>
                                </el-select>
                              </div>
                            </div>
                            <div class="display-f align-i-c">
                              <custom-button size="mini" type="info" :icon="item.ingredients && item.ingredients.length > 0 ? 'el-icon-check' : ''" @click="openIngredient(index)">辅料</custom-button>
                              <el-popconfirm confirm-button-text='确定' confirm-button-type="text" cancel-button-text='取消'
                              icon="el-icon-info" icon-color="red" title="是否确定次操作？"
                              @confirm="delPrescription(index, item.orderCaseProjectRecipeId)">
                              <div slot="reference" class="del-icon ml16"> <span class="iconfont icon-shanch"></span>
                              </div>
                            </el-popconfirm>
                            </div>
                          </div>
                          <div :ref="'pro-item' + index + itemIndex" class="pro-item"
                            v-for="(obj, itemIndex) in item.items" :key="obj.itemId">
                            <div class="w32 tac flex-sh  border-r-dash">{{ itemIndex + 1 }}</div>
                            <div class="flex1 pl12 border-r-dash display-f">
                              <!-- <span>{{ obj.itemName }}</span> -->
                              <el-tooltip
                                v-if="(computedMultiplication(item.doseNum, obj.itemNum) > obj.inventory && obj.onSale == '1') || !obj.inventory"
                                class="item" effect="dark" content="库存不足" placement="top">
                                <span class="iconfont icon-jingg colorFE8F mr8"></span>
                              </el-tooltip>
                              <el-tooltip v-if="obj.onSale == '0'" class="item" effect="dark"
                                content="本店暂无该药品" placement="top">
                                <span class="iconfont icon-tinshou colorF54A mr8"></span>
                              </el-tooltip>
                              <el-select class="drug-select" size="medium" :popper-append-to-body="false"
                                reserve-keyword filterable remote
                                :remote-method="(query) => getDrug(query, item.doseType)"
                                popper-class="customSelectStyle" v-model="obj.itemName" placeholder="输入其他商品或拼音码"
                                @focus="goodsOption = []" @change="drugChange($event, item, index, itemIndex, obj)">
                                <el-option class="display-f" disabled value="null"
                                  style="pointer-events:none; background:#F0F1F3">
                                  <span style="width:150px; display:inline-block">项目名称</span>
                                  <span style="width:70px; display:inline-block" class="text-overflow">规格</span>
                                  <span style="width: 70px; display:inline-block">类型</span>
                                  <span style="width: 80px; display:inline-block">库存</span>
                                  <span style="width: 80px; display:inline-block">价格</span>
                                  <span style="width: 70px; display:inline-block">医保属性</span>
                                  <span style="width: 80px; display:inline-block">spuId</span>
                                </el-option>
                                <el-option class="display-f" v-for="item in goodsOption" :key="item.spuId"
                                  :value="item.spuId">
                                  <span style="width:150px; display:inline-block">{{ item.spuCommonName
                                    }}</span>
                                  <span style="width:70px; display:inline-block" class="text-overflow">{{
                                    item.spec ||
                                    '-'
                                  }}</span>
                                  <span style="width: 70px; display:inline-block">{{ item.firstCategoryName ||
                                    '-'
                                    }}</span>
                                  <span style="width: 80px; display:inline-block">{{
                                    item.inventory ||
                                    '-'
                                  }}</span>
                                  <span style="width: 80px; display:inline-block">{{ item.price
                                    }}</span>
                                  <span style="width: 70px; display:inline-block">{{
                                    computedDictText(item.medicalInsuranceType, ybPropertyList) || '-'
                                  }}</span>
                                   <span style="width: 80px; display:inline-block">{{ item.spuId
                                    }}</span>
                                </el-option>
                              </el-select>
                              <SelectPanel :ref="'operate' + index + itemIndex"
                                :class="{ prescription_decoction: true, prescription_decoction_hide_most: [null, undefined, ''].includes(obj.spuId) } && obj.isOwned == '1'"
                                v-model="obj.handling" width="100%" placeholder="煎法" :columnsNum="4"
                                :options="handlingOptions" @input="chooseUsage($event, index, itemIndex)">
                                <template slot="prefix">
                                  <div class="isOwned_warp" v-if="obj.isOwned && obj.isOwned == '1'">【自备】</div>
                                </template>
                                <template slot="footer">
                                  <div class="prescription_decoction_footer">
                                    <div class="decoction_btn"
                                      :class="obj.isOwned && obj.isOwned == '1' ? 'decoction_btn isOwned' : 'decoction_btn'"
                                      @click="handleIsOwned(index, itemIndex)">【自备】</div>
                                    <div class="decoction_btn"> </div>
                                  </div>
                                </template>
                              </SelectPanel>

                              <span class="color6671 ml8 size13" v-if="item.ybCenterDrugDirectoryCategorySign">【{{
                                computedDictText(item.ybCenterDrugDirectoryCategorySign, ybCenterDrugDirectoryCategorySignList)
                              }}】</span>
                            </div>
                            <custom-input @keydown.enter.native="numberEnter(index)" @blur="computeRecipesTotal"
                              @focus="numberFocus(index, itemIndex)"
                              @keydown.down.native="numberInputMove(index, item, itemIndex, 'down')"
                              @keydown.up.native="numberInputMove(index, item, itemIndex, 'up')"
                              @input="updateDataNum($event, obj)" :ref="index + 'num' + obj.itemId" size="big"
                              class="number-warp" v-model.trim="obj.itemNum"></custom-input>
                            <div class="unit-warp">{{ obj.itemUnit }}</div>
                            <el-popconfirm confirm-button-text='确定' confirm-button-type="text" cancel-button-text='取消'
                              icon="el-icon-info" icon-color="red" title="是否确定次操作？"
                              @confirm="delItem(item, obj.itemId)">
                              <div slot="reference" class="del-warp">
                                <i class="el-icon-close"></i>
                              </div>
                            </el-popconfirm>
                          </div>
                          <!-- 搜索框 -->
                          <div class="drug-search">
                            <el-select :ref="'select' + index" size="medium" :popper-append-to-body="false"
                              reserve-keyword filterable remote
                              :remote-method="(query) => getDrug(query, item.doseType)" popper-class="customSelectStyle"
                              class="search-select" v-model="drugSearchValue" placeholder="输入其他商品或拼音码"
                              @focus="searchFocus" @change="selectGoodsItem($event, item, '1', index)">
                              <el-option disabled class="display-f" value="null"
                                style="pointer-events:none; background:#F0F1F3">
                                <span style="width:150px; display:inline-block" class="text-overflow">项目名称</span>
                                <span style="width:70px; display:inline-block" class="text-overflow">规格</span>
                                <span style="width: 70px; display:inline-block">类型</span>
                                <span style="width: 80px; display:inline-block">库存</span>
                                <span style="width: 60px; display:inline-block">单位</span>
                                <span style="width: 80px; display:inline-block">价格</span>
                                <span style="width: 70px; display:inline-block">医保属性</span>
                                <span style="width: 80px; display:inline-block">spuId</span>
                              </el-option>
                              <el-option v-for="item in goodsOption" :key="item.itemId" :value="item.itemId">
                                <span style="width:150px; display:inline-block" class="text-overflow">{{ item.spuCommonName
                                  }}</span>
                                <span style="width:70px; display:inline-block" class="text-overflow">{{
                                  item.spec ||
                                  '-'
                                }}</span>
                                <span style="width: 70px; display:inline-block">{{ item.firstCategoryName || '-'
                                  }}</span>
                                <span style="width: 80px; display:inline-block">{{ item.inventory ||
                                  '-'
                                  }}</span>
                                <span style="width: 60px; display:inline-block">{{ item.itemUnit ||
                                  '-'
                                  }}</span>
                                <span style="width: 80px; display:inline-block">{{ item.price
                                  }}</span>
                                <span style="width: 70px; display:inline-block">{{
                                  computedDictText(item.medicalInsuranceType, ybPropertyList) || '-'
                                }}</span>
                                <span style="width: 80px; display:inline-block">{{ item.spuId
                                  }}</span>
                              </el-option>
                            </el-select>
                            <i class="el-icon-plus icon"></i>
                            <span class="price-warp">¥{{ item.totalPrice }}</span>
                          </div>
                          <div class="drug-warp-total">
                            <div class="drug-action">
                              <div class="dosage-warp">
                                <custom-input @input="updateDataInteger($event, item, '1')" v-model.trim="item.doseNum"
                                  @blur="computeRecipesTotal"></custom-input>
                                <div>剂</div>
                              </div>
                              <div class="dose">
                                <SelectPanel v-model="item.recipeMethod" width="60px" placeholder="用法" clearable
                                  :options="drugMethodOptions.map(v => { return { label: v, value: v } })"
                                  @input="handDrugs(item, index, true)">
                                </SelectPanel>
                              </div>
                              <div class="dose" v-for="(val, ind) in computedDrugNoteList(item)" :key="ind">
                                <div v-if="val.id == 'mixingBagNum'" class="doseNumber bag"
                                  @click="mixingBagNumFocus(index)" style="white-space: nowrap;">
                                  每次
                                  <el-input :ref="`mixingBagNum_${index}`" v-model.trim="item.mixingBagNum"
                                    style="width: 20px;"
                                    oninput="if(isNaN(value)) { value = null }if( value.indexOf('.') > 0){ value = value.slice(0,value.indexOf('.')+2) } else if ( value.indexOf('.') === 0 ) { value = null }"
                                    :readonly="!val.allowInput" @blur="mixingBagNumBlur"
                                    @change="handDrugs(item, index)"> </el-input>
                                  袋
                                </div>
                                <SelectPanel v-else v-model="item[val.id]" :width="val.width || '80px'"
                                  :columnsNum="val.id === 'doseFrequency' ? 1 : 3"
                                  :options="val.kid.map(v => { return { label: v, value: v } })" :placeholder="val.name"
                                  :readonly="!val.allowInput" clearable @input="handDrugs(item, index)">
                                </SelectPanel>
                              </div>
                              <div class="dose">
                                <el-input style="width: 60px;" placeholder="备注" type="text"
                                  v-model="item.remark"></el-input>
                              </div>
                            </div>
                          </div>
                          <div class="drug_ingredient" v-if="item.ingredients && item.ingredients.length > 0" @click="editIngredient(index)">
                            <div class="drug_ingredient_title">辅料</div>
                            <div>{{ computedIngredients(item.ingredients) }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 医联 -->
                    <div v-for="(item, index) in recipesList" :key="index + 'a'">
                      <div class="project form mt12" v-if="item.recipeType == '1' && item.isYlcp == '1'">
                        <div class="project-title">
                          <div class="display-f align-i-c">
                            <img :src="imgArr.drugIcon" class="title-icon">
                            <div>医联产品</div>
                            <div class="drug-type">
                              <div>类型：</div>
                              <el-select :ref="'typeSelect' + index" class="type-select" v-model="item.doseType"
                                placeholder="" @change="typeChange($event, item, index)">
                                <el-option v-for="obj in recipeList" :key="obj.value" :label="obj.label"
                                  :value="obj.value">
                                </el-option>
                              </el-select>
                            </div>
                            <div class="ml10">{{ item.recipeName }}</div>
                            <div class="ml10" v-if="computedComboItem(item.items, item.doseNum).length > 0">
                              存在{{ computedComboItem(item.items, item.doseNum).length
                              }}味库存不足或停售的商品</div>
                          </div>
                          <el-popconfirm confirm-button-text='确定' confirm-button-type="text" cancel-button-text='取消'
                            icon="el-icon-info" icon-color="red" title="是否确定次操作？"
                            @confirm="delPrescription(index, item.orderCaseProjectRecipeId)">
                            <div slot="reference" class="del-icon"> <span class="iconfont icon-shanch"></span>
                            </div>
                          </el-popconfirm>
                        </div>
                        <div v-for="(obj, itemIndex) in item.items" :key="obj.itemId">
                          <div class="pro-item" :ref="'pro-item' + index + itemIndex"
                            v-if="obj.onSale == '0' || computedMultiplication(item.doseNum, obj.itemNum) > obj.inventory || obj.isShow">
                            <div class="w32 tac flex-sh  border-r-dash">{{ itemIndex + 1
                              }}</div>
                            <div class="flex1 pl12 border-r-dash display-f">
                              <el-tooltip
                                v-if="(computedMultiplication(item.doseNum, obj.itemNum) > obj.inventory && obj.onSale == '1') || !obj.inventory"
                                class="item" effect="dark" content="库存不足" placement="top">
                                <span class="iconfont icon-jingg colorFE8F mr8"></span>
                              </el-tooltip>
                              <el-tooltip v-if="obj.onSale == '0'" class="item" effect="dark"
                                content="本店暂无该药品" placement="top">
                                <span class="iconfont icon-tinshou colorF54A mr8"></span>
                              </el-tooltip>
                              <el-select class="drug-select" size="medium" :popper-append-to-body="false"
                                reserve-keyword filterable remote
                                :remote-method="(query) => getDrug(query, item.doseType)"
                                popper-class="customSelectStyle" v-model="obj.itemName" placeholder="输入其他商品或拼音码"
                                @focus="searchFocus" @change="drugChange($event, item, index, itemIndex, obj)">
                                <el-option class="display-f" disabled value="null"
                                  style="pointer-events:none; background:#F0F1F3">
                                  <span style="width:150px; display:inline-block" class="text-overflow">项目名称</span>
                                  <span style="width:70px; display:inline-block">规格</span>
                                  <span style="width: 70px; display:inline-block">类型</span>
                                  <span style="width: 80px; display:inline-block">库存</span>
                                  <span style="width: 80px; display:inline-block">价格</span>
                                  <span style="width: 70px; display:inline-block">医保</span>
                                  <span style="width: 80px; display:inline-block">spuId</span>
                                </el-option>
                                <el-option class="display-f" v-for="item in goodsOption" :key="item.itemId"
                                  :value="item.itemId">
                                  <span style="width:150px; display:inline-block" class="text-overflow">{{ item.spuCommonName
                                    }}</span>
                                  <span style="width:70px; display:inline-block">{{
                                    item.spec ||
                                    '-'
                                  }}</span>
                                  <span style="width: 70px; display:inline-block">{{ item.firstCategoryName ||
                                    '-'
                                    }}</span>
                                  <span style="width: 80px; display:inline-block">{{
                                    item.inventory ||
                                    '-'
                                  }}</span>
                                  <span style="width: 80px; display:inline-block">{{ item.price
                                    }}</span>
                                  <span style="width: 70px; display:inline-block">{{
                                    computedDictText(item.medicalInsuranceType, ybPropertyList) || '-'
                                  }}</span>
                                   <span style="width: 80px; display:inline-block">{{ item.spuId
                                    }}</span>
                                </el-option>
                              </el-select>
                              <SelectPanel :ref="'operate' + index + itemIndex"
                                :class="{ prescription_decoction: true, prescription_decoction_hide_most: [null, undefined, ''].includes(obj.spuId) }"
                                v-model="obj.handling" width="100%" placeholder="煎法" :columnsNum="4"
                                :options="handlingOptions" @input="chooseUsage($event, index, itemIndex)">
                                <template slot="footer">
                                  <div class="prescription_decoction_footer">
                                    <div class="decoction_btn"></div>
                                    <div class="decoction_btn"> </div>
                                  </div>
                                </template>
                              </SelectPanel>
                              <span class="color6671 ml8 size13" v-if="item.ybCenterDrugDirectoryCategorySign">【{{
                                computedDictText(item.ybCenterDrugDirectoryCategorySign, ybCenterDrugDirectoryCategorySignList)
                              }}】</span>
                            </div>
                            <custom-input @keydown.enter.native="numberEnter(index)" @blur="computeRecipesTotal"
                              @focus="numberFocus(index, itemIndex)"
                              @keydown.down.native="numberInputMove(index, item, itemIndex, 'down')"
                              @keydown.up.native="numberInputMove(index, item, itemIndex, 'up')"
                              @input="updateDataNum($event, obj)" :ref="index + 'num' + obj.itemId" size="big"
                              class="number-warp" v-model.trim="obj.itemNum"></custom-input>
                            <div class="unit-warp">{{ obj.itemUnit }}</div>
                            <el-popconfirm confirm-button-text='确定' confirm-button-type="text" cancel-button-text='取消'
                              icon="el-icon-info" icon-color="red" title="是否确定次操作？"
                              @confirm="delItem(item, obj.itemId)">
                              <div slot="reference" class="del-warp">
                                <i class="el-icon-close"></i>
                              </div>
                            </el-popconfirm>
                          </div>
                        </div>
                        <div class="drug-warp-total">
                          <div class="drug-action">
                            <div class="dosage-warp">
                              <custom-input @input="updateDataInteger($event, item, '1')" v-model.trim="item.doseNum"
                                @blur="computeRecipesTotal"></custom-input>
                              <div>剂</div>
                            </div>
                            <div class="dose">
                              <SelectPanel v-model="item.recipeMethod" width="60px" placeholder="用法" clearable
                                :options="drugMethodOptions.map(v => { return { label: v, value: v } })"
                                @input="handDrugs(item, index, true)"></SelectPanel>
                            </div>
                            <div class="dose" v-for="(val, ind) in computedDrugNoteList(item)" :key="ind">
                              <div v-if="val.id == 'mixingBagNum'" class="doseNumber bag"
                                @click="mixingBagNumFocus(index)">
                                每次
                                <el-input :ref="`mixingBagNum_${index}`" v-model.trim="item.mixingBagNum"
                                  style="width: 20px;"
                                  oninput="if(isNaN(value)) { value = null }if( value.indexOf('.') > 0){ value = value.slice(0,value.indexOf('.')+2) } else if ( value.indexOf('.') === 0 ) { value = null }"
                                  :readonly="!val.allowInput" @blur="mixingBagNumBlur" @change="handDrugs(item, index)">
                                </el-input>
                                袋
                              </div>
                              <SelectPanel v-else v-model="item[val.id]" :width="val.width || '80px'"
                                :columnsNum="val.id === 'doseFrequency' ? 1 : 3"
                                :options="val.kid.map(v => { return { label: v, value: v } })" :placeholder="val.name"
                                :readonly="!val.allowInput" clearable @input="handDrugs(item, index)">
                              </SelectPanel>
                            </div>
                            <div class="dose">
                              <el-input style="width: 140px;" placeholder="备注" type="text"
                                v-model="item.remark"></el-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 中成药处方 -->
                    <div v-for="(item, index) in recipesList" :key="index + 'b'">
                      <div class="project form mt12" v-if="item.recipeType == '4' && item.recipeSourceType != '0'">
                        <div class="project-title">
                          <div class="display-f align-i-c">
                            <img :src="imgArr.phyIcon" class="title-icon">
                            <div>中成药处方</div>
                          </div>
                          <el-popconfirm confirm-button-text='确定' confirm-button-type="text" cancel-button-text='取消'
                            icon="el-icon-info" icon-color="red" title="是否确定次操作？"
                            @confirm="delPrescription(index, item.orderCaseProjectRecipeId)">
                            <div slot="reference" class="del-icon"> <span class="iconfont icon-shanch"></span>
                            </div>
                          </el-popconfirm>
                        </div>
                        <div class="" :ref="'pro-item' + index + itemIndex"
                          v-for="(obj, itemIndex) in item.items" :key="obj.itemId">
                          <div class="pro-item">
                            <div class="w32 tac flex-sh  border-r-dash">{{ itemIndex + 1 }}</div>
                            <div class="flex1 pl12 border-r-dash display-f">
                              <!-- <span>{{ obj.itemName }}</span> -->
                               <el-tooltip
                                  v-if="(obj.itemNum > obj.inventory && obj.onSale == '1') || !obj.inventory"
                                  class="item" effect="dark" content="库存不足" placement="top">
                                  <span class="iconfont icon-jingg colorFE8F mr8"></span>
                                </el-tooltip>
                                <el-tooltip v-if="obj.onSale == '0'" class="item" effect="dark"
                                  content="本店暂无该药品" placement="top">
                                  <span class="iconfont icon-tinshou colorF54A mr8"></span>
                                </el-tooltip>
                              <el-select class="drug-select" size="medium" :popper-append-to-body="false" reserve-keyword
                                filterable remote :remote-method="getChineseMedicien" popper-class="customSelectStyle"
                                v-model="obj.itemName" placeholder="输入其他商品或拼音码"
                                @change="chineseMedicineChange($event, item, index, itemIndex)">
                                <el-option class="display-f" disabled value="null"
                                  style="pointer-events:none; background:#F0F1F3">
                                  <span style="width:150px; display:inline-block" class="text-overflow">项目名称</span>
                                  <span style="width:70px; display:inline-block">规格</span>
                                  <span style="width: 70px; display:inline-block">类型</span>
                                  <span style="width: 80px; display:inline-block">库存</span>
                                  <span style="width: 80px; display:inline-block">价格</span>
                                  <span style="width: 70px; display:inline-block">医保属性</span>
                                  <span style="width: 80px; display:inline-block">spuId</span>
                                </el-option>
                                <el-option class="display-f" v-for="item in chineseMedicineOption" :key="item.itemId"
                                  :value="item.itemId" :label="item.spuCommonName">
                                  <span style="width:150px; display:inline-block" class="text-overflow">{{ item.spuCommonName
                                    }}</span>
                                  <span style="width:70px; display:inline-block">{{
                                    item.spec ||
                                    '-'
                                  }}</span>
                                  <span style="width: 70px; display:inline-block">{{ item.firstCategoryName || '-'
                                    }}</span>
                                  <span style="width: 80px; display:inline-block">{{ item.inventory ||
                                    '-'
                                    }}</span>
                                  <span style="width: 80px; display:inline-block">{{ item.price
                                    }}</span>
                                  <span style="width: 70px; display:inline-block">{{
                                    computedDictText(item.medicalInsuranceType, ybPropertyList) || '-'
                                  }}</span>
                                  <span style="width: 80px; display:inline-block">{{ item.spuId
                                    }}</span>
                                </el-option>
                              </el-select>
                              <span class="color6671 ml8 size13" v-if="item.ybCenterDrugDirectoryCategorySign">【{{
                                computedDictText(item.ybCenterDrugDirectoryCategorySign, ybCenterDrugDirectoryCategorySignList)
                              }}】</span>
                            </div>
                            <custom-input @keydown.enter.native="numberEnter(index)" @blur="computeRecipesTotal"
                              @focus="numberFocus(index, itemIndex)"
                              @keydown.down.native="numberInputMove(index, item, itemIndex, 'down')"
                              @keydown.up.native="numberInputMove(index, item, itemIndex, 'up')"
                              @input="updateDataNum($event, obj)" :ref="index + 'num' + obj.itemId" size="big"
                              class="number-warp" v-model.trim="obj.itemNum"></custom-input>
                            <div class="unit-warp">{{ obj.itemUnit }}</div>
                            <el-popconfirm confirm-button-text='确定' confirm-button-type="text" cancel-button-text='取消'
                              icon="el-icon-info" icon-color="red" title="是否确定次操作？" @confirm="delItem(item, obj.itemId)">
                              <div slot="reference" class="del-warp">
                                <i class="el-icon-close"></i>
                              </div>
                            </el-popconfirm>
                          </div>
                           <div class="add-warp-bottom" v-if="obj.itemName">
                            <div class="method-warp">
                              <SelectPanel v-model="obj.useFrequency" :options="dictData.useFrequency" width="60px" placeholder="用法"
                                valueKey="dictCode" labelKey="dictLabel" readonly></SelectPanel>
                              <div class="singleDose-warp">
                                <div class="pb3 flex-sh">1次</div>
                                <el-input class="singleDose-input" maxlength="3" type="text"
                                  v-model="obj.singleDose" @input="singleDoseChange(obj)"
                                  style=" width: 40px;"></el-input>
                                <SelectPanel v-model="obj.singleDoseUnit" :options="dictData.singleDoseUnit" width="50px"
                                  placeholder="单位" :caretShow="true" valueKey="dictCode" labelKey="dictLabel"
                                  readonly></SelectPanel>
                              </div>
                              <SelectPanel class="ml8" v-model="obj.takingTime" :options="dictData.takingTime" width="80px"
                                placeholder="服用时间" valueKey="dictCode" labelKey="dictLabel" readonly></SelectPanel>
                              <SelectPanel class="ml8" v-model="obj.intervalRequirement" :options="dictData.intervalRequirement"
                                width="130px" valueKey="dictCode" labelKey="dictLabel" placeholder="时间间隔要求"
                                :itemWidth="160" readonly></SelectPanel>
                            </div>
                          </div>
                        </div>
                        <!-- 搜索框 -->
                        <div class="drug-search">
                          <el-select :ref="'select' + index" size="medium" :popper-append-to-body="false" filterable
                            remote :remote-method="getChineseMedicien" popper-class="customSelectStyle"
                            class="search-select" v-model="drugSearchValue" placeholder="输入其他商品或拼音码"
                            @change="selectGoodsItem($event, item, '4', index)">
                            <el-option class="display-f" disabled value="null"
                              style="pointer-events:none; background:#F0F1F3">
                              <span style="width:150px; display:inline-block" class="text-overflow">项目名称</span>
                              <span style="width:70px; display:inline-block">规格</span>
                              <span style="width:70px; display:inline-block">单位</span>
                              <span style="width: 70px; display:inline-block">类型</span>
                              <span style="width: 80px; display:inline-block">库存</span>
                              <span style="width: 80px; display:inline-block">价格</span>
                              <span style="width: 70px; display:inline-block">医保属性</span>
                              <span style="width: 80px; display:inline-block">spuId</span>
                            </el-option>
                            <el-option v-for="item in chineseMedicineOption" :key="item.itemId" :value="item.itemId"
                              :label="item.spuCommonName">
                              <span style="width:150px; display:inline-block" class="text-overflow">{{ item.spuCommonName
                                }}</span>
                              <span style="width:70px; display:inline-block">{{ item.spec || '-'
                                }}</span>
                              <span style="width:70px; display:inline-block">{{ item.itemUnit || '-'
                                }}</span>
                              <span style="width: 70px; display:inline-block">{{ item.firstCategoryName || '-'
                                }}</span>
                              <span style="width: 80px; display:inline-block">{{ item.inventory || '-'
                                }}</span>
                              <span style="width: 80px; display:inline-block">{{ item.price }}</span>
                              <span style="width: 70px; display:inline-block">{{
                                computedDictText(item.medicalInsuranceType, ybPropertyList) || '-'
                              }}</span>
                               <span style="width: 80px; display:inline-block">{{ item.spuId }}</span>
                            </el-option>
                          </el-select>
                          <i class="el-icon-plus icon"></i>
                          <span class="price-warp">¥{{ item.totalPrice }}</span>
                        </div>
                       
                      </div>
                    </div>
                    <!-- 理疗处方 -->
                    <div v-for="(item, index) in recipesList" :key="index + 'c'">
                      <div class="project form mt12" v-if="item.recipeType == '3' && item.recipeSourceType != '0'">
                        <div class="project-title">
                          <div class="display-f align-i-c">
                            <img :src="imgArr.phyIcon" class="title-icon">
                            <div>理疗处方</div>
                          </div>
                          <el-popconfirm confirm-button-text='确定' confirm-button-type="text" cancel-button-text='取消'
                            icon="el-icon-info" icon-color="red" title="是否确定次操作？"
                            @confirm="delPrescription(index, item.orderCaseProjectRecipeId)">
                            <div slot="reference" class="del-icon"> <span class="iconfont icon-shanch"></span>
                            </div>
                          </el-popconfirm>
                        </div>
                        <div v-for="(obj, itemIndex) in item.items" :key="obj.itemId">
                          <div class="pro-item" :ref="'pro-item' + index + itemIndex">
                          <div class="w32 tac flex-sh  border-r-dash">{{ itemIndex + 1 }}</div>
                          <div class="flex1 pl12 border-r-dash">
                            <!-- <span>{{ obj.itemName }}</span> -->
                            <el-tooltip v-if="obj.enableStatus === 2" class="item" effect="dark" content="该理疗项目已被禁用"
                              placement="top">
                              <span class="iconfont icon-tinshou colorF54A mr8"></span>
                            </el-tooltip>
                            <el-select class="drug-select" size="medium" :popper-append-to-body="false" filterable remote reserve-keyword :remote-method="getPhysioList"
                              popper-class="customSelectStyle" v-model="obj.itemName" placeholder="输入其他商品或拼音码"
                              @change="physioChange($event, item, index, itemIndex)" @focus="physioOption = []">
                              <el-option class="display-f" disabled value="null"
                                style="pointer-events:none; background:#F0F1F3">
                                <span style="width:150px; display:inline-block" class="text-overflow">项目名称</span>
                                <span style="width:70px; display:inline-block">规格</span>
                                <span style="width: 70px; display:inline-block">类型</span>
                                <span style="width: 80px; display:inline-block">库存</span>
                                <span style="width: 80px; display:inline-block">价格</span>
                                <span style="width: 70px; display:inline-block">医保属性</span>
                                <span style="width: 80px; display:inline-block">spuId</span>
                              </el-option>
                              <el-option class="display-f" v-for="item in physioOption" :key="item.itemId"
                                :value="item.itemId" :label="item.spuCommonName">
                                <span style="width:150px; display:inline-block" class="text-overflow">{{ item.spuCommonName
                                  }}</span>
                                <span style="width:70px; display:inline-block">{{
                                  item.spec ||
                                  '-'
                                }}</span>
                                <span style="width: 70px; display:inline-block">{{ item.firstCategoryName || '-'
                                  }}</span>
                                <span style="width: 80px; display:inline-block">{{ item.inventory ||
                                  '-'
                                  }}</span>
                                <span style="width: 80px; display:inline-block">{{ item.price
                                  }}</span>
                                <span style="width: 70px; display:inline-block">{{
                                computedDictText(item.medicalInsuranceType, ybPropertyList) || '-'
                              }}</span>
                                <span style="width: 80px; display:inline-block">{{ item.spuId
                                  }}</span>
                              </el-option>
                            </el-select>
                          </div>
                          <div class="physio_item_price">单位：{{ obj.itemUnit }}</div>
                          <div class="physio_item_price" v-if="obj.physioExtendJson && obj.physioExtendJson.executionMode == 20"> 
                            <div>￥{{obj.price.toFixed(2)}}/组 </div>
                            <el-tooltip placement="bottom" popper-class="risk-tooltip" v-if="obj.effectDrugPriceConfig && obj.effectDrugPriceConfig.configType == 2">
                              <div slot="content">
                                <div v-for="config in obj.effectDrugPriceConfig.ladderPriceConfigs">
                                  <div v-if="config.ladderEndNumber">{{ config.ladderStartNumber }}-{{ config.ladderEndNumber }}{{obj.physioExtendJson.executionMode == 10 ? '次': '组'}}，{{ config.ladderPrice }}元/{{ obj.physioExtendJson.executionMode == 10 ? '次': '组' }}</div>
                                  <div v-else>{{ config.ladderStartNumber }}{{ obj.physioExtendJson.executionMode == 10 ? '次': '组' }}及以上，{{ config.ladderPrice }}元/{{ obj.physioExtendJson.executionMode == 10 ? '次': '组' }}</div>
                                </div>
                              </div>
                              <i class="el-icon-warning-outline"></i>
                            </el-tooltip>
                          </div>
                          <div class="physio_item_price" v-if="obj.physioExtendJson">
                            <div class="ml5 item-section">￥</div>
                            <div>{{obj.physioExtendJson.executionMode == 20 ? $bigNumber(obj.price, '*', obj.physioExtendJson.onlyNum) : obj.price}}</div>
                            <div class="ml5 item-section">每 次</div>
                            <el-tooltip placement="bottom" popper-class="risk-tooltip" v-if="obj.effectDrugPriceConfig && obj.effectDrugPriceConfig.configType == 2">
                              <div slot="content">
                                <div v-for="config in obj.effectDrugPriceConfig.ladderPriceConfigs">
                                  <div v-if="config.ladderEndNumber">{{ config.ladderStartNumber }}-{{ config.ladderEndNumber }}{{obj.physioExtendJson.executionMode == 10 ? '次': '组'}}，{{ config.ladderPrice }}元/{{ obj.physioExtendJson.executionMode == 10 ? '次': '组' }}</div>
                                  <div v-else>{{ config.ladderStartNumber }}{{ obj.physioExtendJson.executionMode == 10 ? '次': '组' }}及以上，{{ config.ladderPrice }}元/{{ obj.physioExtendJson.executionMode == 10 ? '次': '组' }}</div>
                                </div>
                              </div>
                              <i v-if="obj.physioExtendJson.executionMode == 10" class="el-icon-warning-outline"></i>
                            </el-tooltip>
                          </div>
                          <el-popconfirm confirm-button-text='确定' confirm-button-type="text" cancel-button-text='取消'
                            icon="el-icon-info" icon-color="red" title="是否确定次操作？" @confirm="delItem(item, obj.itemId)">
                            <div slot="reference" class="del-warp">
                              <i class="el-icon-close"></i>
                            </div>
                          </el-popconfirm>
                          </div>
                          <div class="acupoint-warp">
                            <div class="acupoint-list">
                              <div class="acupoint-item"
                                v-for="(acupoint, acupointIndex) in obj.physioExtendJson && obj.physioExtendJson.acupointinfoList"
                                :key="acupoint.acupointId">
                                <div class="acupoint-item-tips" v-if="alreadyAdd == `note${index}${itemIndex}${acupointIndex}`">已添加过该{{ acupoint.speciesType == 10 ? '穴位' : '部位' }}</div>
                                <div class="acupoint-item-tips" v-if="speciesTypeTips == `note${index}${itemIndex}${acupointIndex}`">选择{{ acupoint.speciesType == 10 ? '穴位' : '部位'}}不计入{{ acupoint.speciesType == 10 ? '部位' : '穴位'}}数</div>
                                <el-popover :ref="'popover' + index + itemIndex + acupointIndex" placement="bottom" trigger="click"
                                  popper-class="acupoint-popover" :disabled="acupoint.type == 10">
                                  <!-- 普通穴位 -->
                                  <div class="acupoint-position" v-if="acupoint.type != 50 && acupoint.type != 60">
                                    <div class="acupoint-position-item"
                                      :class="{ 'acupoint-position-item-active': acupoint.type == type.value ? true : false,
                                        'acupoint-position-item-disabled':acupoint.type != 10 && type.value == 10
                                       }"
                                      v-for="type in acupointType" :key="type.value"
                                      @click="changeAcupointType(type.value,acupoint,index,itemIndex,acupointIndex )">{{ type.label }}</div>
                                  </div>
                                  <!-- 阿是穴 -->
                                  <div class="acupoint-position" v-if="acupoint.type == 50">
                                    <div class="acupoint-position-item"
                                      :class="{ 'acupoint-position-item-active': type == computedAcupointType(acupoint.type,acupoint.typeExtend) ? true : false ,
                                      'acupoint-position-item-disabled': acupoint.type != 10 && type.value == 10}"
                                      v-for="type in AshiPoints" :key="type"
                                      @click="changeAcupointType(type,acupoint,index,itemIndex,acupointIndex )">{{ type }}</div>
                                  </div>
                                  <!-- 四缝穴 -->
                                  <div class="acupoint-SiFen" v-if="acupoint.type == 60">
                                    <div>左手：</div>
                                    <el-checkbox-group v-model="acupoint.typeExtend" class="mt6" :min="1" @change="$forceUpdate()">
                                      <el-checkbox v-for="item in SiFenLeft" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                                    </el-checkbox-group>
                                    <div class="mt12">右手：</div>
                                    <el-checkbox-group v-model="acupoint.typeExtend" class="mt6" :min="1" @change="$forceUpdate()">
                                      <el-checkbox v-for="item in SiFenRight" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                                    </el-checkbox-group>
                                  </div>
                                  <el-button slot="reference" class="acupoint-item-left">{{
                                    computedAcupointType(acupoint.type,acupoint.typeExtend)
                                  }}</el-button>
                                </el-popover>
                                <el-select v-model="acupoint.acupointName" :default-first-option="true"
                                  :placeholder="obj.physioExtendJson && obj.physioExtendJson.perUnit | filterPerUnit"
                                  filterable popper-class="customSelectStyle" remote reserve-keyword
                                  :remote-method="query => getAcupointsList(query)"
                                  @change="changeAcupoint($event, index, itemIndex, acupointIndex)">
                                  <el-option v-for="item in acupointOptions" :key="item.acupointId" :label="item.acupointName"
                                    :value="item.acupointId">
                                  </el-option>
                                </el-select>
                                <i class="el-icon-close" @click="deleteAcupoint(index, itemIndex, acupointIndex)"></i>
                              </div>
                              <div class="acupoint-item">
                                <div class="acupoint-item-tips" v-if="alreadyAdd == `note${index}${itemIndex}`">已添加过该{{
                                  obj.physioExtendJson && obj.physioExtendJson.perUnit | filterPerUnit }}</div>
                                <el-select v-model="acupointName" :default-first-option="true"
                                  :placeholder="obj.physioExtendJson && obj.physioExtendJson.perUnit | filterPerUnit"
                                  filterable popper-class="customSelectStyle" remote reserve-keyword
                                  :remote-method="query => getAcupointsList(query)" :ref="'search' + index + itemIndex"
                                  @change="selectAcupointName($event,obj,index,itemIndex )">
                                  <el-option v-for="item in acupointOptions" :key="item.acupointId" :label="item.acupointName"
                                    :value="item.acupointId">
                                  </el-option>
                                </el-select>
                                <div class="acupoint-item-icon" @click="openAcupoint(index, itemIndex)">
                                  <img :src="imgArr.acupointIcon" class="acupoint-icon" alt="">
                                </div>
                              </div>
                             </div>
                             <div class="acupoint-total" :class="{'color667':computedPerUnitCount(obj.physioExtendJson) < computedMultiplication(obj.physioExtendJson.perUnitCount,obj.physioExtendJson.onlyNum)}" v-if="obj.physioExtendJson && obj.physioExtendJson.executionMode && obj.physioExtendJson.perUnitCount">{{obj.physioExtendJson && obj.physioExtendJson.perUnit | filterPerUnitShow}}：
                                {{ computedPerUnitCount(obj.physioExtendJson) }} / {{ computedMultiplication(obj.physioExtendJson.perUnitCount,obj.physioExtendJson.onlyNum) }}
                              </div>
                              <div class="acupoint-total" v-else>{{ obj.physioExtendJson && obj.physioExtendJson.perUnit | filterPerUnitShow}}：
                                {{ computedPerUnitCount(obj.physioExtendJson) }}
                              </div>
                          </div>
                          <div class="other-warp" >
                            <div class="other-warp-left" v-if="obj.physioExtendJson">
                              <div class="other-num-input">
                                <el-input class="num-input" v-model="obj.physioExtendJson.soldNum"
                                  @input="soldNumChange($event, index, itemIndex)"></el-input>
                                <div>次</div>
                              </div>
                              <div class="other-num-input" @click="clickOnlyNum(index,itemIndex)"
                                v-if="obj.physioExtendJson && obj.physioExtendJson.executionMode == 20">
                                <div class="flex-sh">1次</div>
                                <el-input class="onlyNum-input" v-model="obj.physioExtendJson.onlyNum" :ref="'frequencyInput'+index+itemIndex"
                                  @input="onlyNumChange($event, index, itemIndex)"></el-input>
                                <div>组</div>
                              </div>
                              <div class="frequency-input">
                                <SelectPanel v-model="obj.executeDesc" :width="'80px'" :columnsNum="3"
                                  :options="physioIntervalEnumOption" :readonly="true" placeholder="频率"
                                  @input="physioIntervalEnumChange($event, obj)">
                                </SelectPanel>
                              </div>
                              <div class="other-desc"
                                v-if="obj.physioExtendJson && obj.physioExtendJson.executionMode == 20 && obj.physioExtendJson.perUnitCount">
                                每组{{ obj.physioExtendJson.perUnitCount}}个{{obj.physioExtendJson.perUnit == 10 ? '穴位' : '部位'}}，每次至少选择{{
                                  $bigNumber(obj.physioExtendJson.perUnitCount, '*',
                                    obj.physioExtendJson.onlyNum)
                                }}个{{obj.physioExtendJson.perUnit == 10 ? '穴位' : '部位'}}</div>
                                <div class="other-desc" v-if="obj.physioExtendJson && obj.physioExtendJson.executionMode == 10 && obj.physioExtendJson.perUnitCount">
                                 每次至少选择{{obj.physioExtendJson.perUnitCount}}个{{ obj.physioExtendJson.perUnit == 10 ? '穴位' : '部位' }}</div>
                                <!-- 需求先备注 -->
                              <!-- <div>
                                <el-input class="remark-input" placeholder="备注" type="text" style="width: 140px;"
                                  clearable v-model="obj.remark"></el-input>
                              </div> -->
                              <div class="other-tips" v-if="computedShowTips(obj.physioExtendJson)"><span class="iconfont icon-jingg colorFE8F mr6" style="size: 12px;"></span>选{{ obj.physioExtendJson.perUnit == 10 ? '部位' : '穴位'}}不计入已选数量</div>
                            </div>
                            <div class="other-warp-right">￥{{ obj.totalPrice }}</div>
                          </div>

                          <div class="remark_warp">
                            <div class="physio_remark_row">
                              <div class="physio_remark_label">理疗备注:</div>
                              <el-input
                                class="physio_product_remark"
                                type="textarea"
                                v-model="obj.remark"
                                placeholder="填写相关项目备注信息"
                                :autosize="{ minRows: 1, maxRows: 3 }"
                                resize="none"
                                clearable
                                maxlength="100"
                                show-word-limit
                                @input="physioRemarkInput(obj)"
                                @blur="physioRemarkBlur(obj)">
                              </el-input>
                            </div>
                          </div>

                        </div>
                        <!-- 搜索框 -->
                        <div class="drug-search" style="border-bottom: none;">
                          <el-select :ref="'select' + index" size="medium" :popper-append-to-body="false" filterable remote reserve-keyword :remote-method="getPhysioList"
                            popper-class="customSelectStyle" class="search-select" v-model="drugSearchValue"
                            placeholder="输入其他商品或拼音码" @change="selectGoodsItem($event, item, '3', index)" @focus="physioOption = []">
                            <el-option class="display-f" disabled value="null"
                              style="pointer-events:none; background:#F0F1F3">
                              <span style="width:150px; display:inline-block" class="text-overflow">项目名称</span>
                              <span style="width:70px; display:inline-block">单位</span>
                              <span style="width: 70px; display:inline-block">类型</span>
                              <span style="width: 80px; display:inline-block">库存</span>
                              <span style="width: 80px; display:inline-block">价格</span>
                              <span style="width: 70px; display:inline-block">医保属性</span>
                              <span style="width: 80px; display:inline-block">spuId</span>
                            </el-option>
                            <el-option v-for="item in physioOption" :key="item.itemId" :value="item.itemId"
                              :label="item.spuCommonName">
                              <span style="width:150px; display:inline-block" class="text-overflow">{{ item.spuCommonName
                                }}</span>
                              <span style="width:70px; display:inline-block">{{ item.itemUnit || '-'
                                }}</span>
                              <span style="width: 70px; display:inline-block">{{ item.firstCategoryName || '-'
                                }}</span>
                              <span style="width: 80px; display:inline-block">{{ item.inventory || '-'
                                }}</span>
                              <span style="width: 80px; display:inline-block">{{ item.price }}</span>
                              <span style="width: 70px; display:inline-block">{{
                                computedDictText(item.medicalInsuranceType, ybPropertyList) || '-'
                              }}</span>
                              <span style="width: 80px; display:inline-block">{{ item.spuId }}</span>
                            </el-option>
                          </el-select>
                          <i class="el-icon-plus icon"></i>
                          <span class="price-warp">¥{{ item.totalPrice }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="actList.length > 0" class="activity_section">
                      <ActivityProject ref="activityProject" :source="3" :deptId="deptId" :orderId="dialogObj.orderId" :actList="actList" :isEdit="true"></ActivityProject>
                    </div>
                    <!-- 非处方项目 -->
                    <div v-for="(item, index) in recipesList" :key="index + 'd'">
                      <div class="form project mt12" v-if="item.recipeType == '0'">
                        <div class="title">非处方项目</div>
                        <div class="pro-item"
                          :ref="'pro-item' + index + itemIndex"
                          v-for="(obj, itemIndex) in otherProjectList(item.items)"
                          :key="obj.itemId">
                          <div class="w32 tac flex-sh  border-r-dash">{{ itemIndex + 1 }}</div>
                          <div class="flex1 pl12 border-r-dash display-f">
                            <!-- <span>{{ obj.itemName }}</span> -->
                             <el-tooltip
                                v-if="(obj.itemNum > obj.inventory && obj.onSale == '1') || !obj.inventory"
                                class="item" effect="dark" content="库存不足" placement="top">
                                <span class="iconfont icon-jingg colorFE8F mr8"></span>
                              </el-tooltip>
                              <el-tooltip v-if="obj.onSale == '0'" class="item" effect="dark"
                                content="本店暂无该药品" placement="top">
                                <span class="iconfont icon-tinshou colorF54A mr8"></span>
                              </el-tooltip>
                            <el-select size="medium" :popper-append-to-body="false" reserve-keyword filterable remote
                              :remote-method="getOther" popper-class="customSelectStyle" class="drug-select"
                              v-model="obj.itemName" placeholder="输入其他商品或拼音码" @focus="searchFocus"
                              @change="otherChange($event, item, index, itemIndex)">
                              <el-option class="display-f" disabled value="null"
                                style="pointer-events:none; background:#F0F1F3">
                                <span style="width:150px; display:inline-block" class="text-overflow">项目名称</span>
                                <span style="width:70px; display:inline-block" class="text-overflow">规格</span>
                                <span style="width: 70px; display:inline-block">类型</span>
                                <span style="width:80px; display:inline-block">库存</span>
                                <span style="width: 80px; display:inline-block">价格</span>
                                <span style="width: 70px; display:inline-block">医保属性</span>
                                <span style="width: 80px; display:inline-block">spuId</span>
                              </el-option>
                              <el-option class="display-f" v-for="item in otherOption" :key="item.itemId"
                                :value="item.itemId">
                                <span style="width:150px; display:inline-block" class="text-overflow">{{ item.spuCommonName
                                  }}</span>
                                <span style="width:70px; display:inline-block" class="text-overflow">{{
                                  item.spec ||
                                  '-'
                                }}</span>
                                <span style="width: 70px; display:inline-block">{{ item.firstCategoryName || '-'
                                  }}</span>
                                <span style="width: 80px; display:inline-block">{{ item.inventory ||
                                  '-'
                                  }}</span>
                                <span style="width: 80px; display:inline-block">{{ item.price
                                  }}</span>
                                <span style="width: 70px; display:inline-block">{{
                                  computedDictText(item.medicalInsuranceType, ybPropertyList) || '-'
                                }}</span>
                                 <span style="width: 80px; display:inline-block">{{ item.spuId
                                  }}</span>
                              </el-option>
                            </el-select>
                          </div>
                          <custom-input @keydown.enter.native="numberEnter(index)" @focus="numberFocus(index, itemIndex)"
                            @keydown.down.native="numberInputMove(index, item, itemIndex, 'down')"
                            @keydown.up.native="numberInputMove(index, item, itemIndex, 'up')"
                            @input="updateDataNum($event, obj)" :ref="index + 'num' + obj.itemId" size="big"
                            class="number-warp" v-model.trim="obj.itemNum"></custom-input>
                          <div class="unit-warp">{{ obj.itemUnit }}</div>
                          <el-popconfirm confirm-button-text='确定' confirm-button-type="text" cancel-button-text='取消'
                            icon="el-icon-info" icon-color="red" title="是否确定次操作？" @confirm="delItem(item, obj.itemId)">
                            <div slot="reference" class="del-warp">
                              <i class="el-icon-close"></i>
                            </div>
                          </el-popconfirm>
                        </div>
                        <div class="drug-search border-bottom-none">
                          <el-select size="medium" :ref="'select' + index" :popper-append-to-body="false"
                            reserve-keyword filterable remote :remote-method="getOther" popper-class="customSelectStyle"
                            class="search-select" v-model="drugSearchValue" placeholder="输入其他商品或拼音码"
                            @focus="searchFocus" @change="selectGoodsItem($event, item, '0', index)">
                            <el-option disabled value="null" style="pointer-events:none; background:#F0F1F3">
                              <span style="width:150px; display:inline-block" class="text-overflow">项目名称</span>
                              <span style="width:70px; display:inline-block" class="text-overflow">规格</span>
                              <span style="width: 70px; display:inline-block">类型</span>
                              <span style="width: 80px; display:inline-block">库存</span>
                              <span style="width: 60px; display:inline-block">单位</span>
                              <span style="width: 80px; display:inline-block">价格</span>
                              <span style="width: 70px; display:inline-block">医保属性</span>
                              <span style="width: 80px; display:inline-block">spuId</span>
                            </el-option>
                            <el-option v-for="item in otherOption" :key="item.itemId" :value="item.itemId">
                              <span style="width:150px; display:inline-block" class="text-overflow">{{ item.spuCommonName
                                }}</span>
                              <span style="width:70px; display:inline-block" class="text-overflow">{{
                                item.spec ||
                                '-'
                              }}</span>
                              <span style="width: 70px; display:inline-block">{{ item.firstCategoryName || '-'
                                }}</span>
                              <span style="width: 80px; display:inline-block">{{ item.inventory || '-'
                                }}</span>
                              <span style="width: 60px; display:inline-block">{{ item.itemUnit || '-'
                                }}</span>
                              <span style="width: 80px; display:inline-block">{{ item.price }}</span>
                              <span style="width: 70px; display:inline-block">{{
                                computedDictText(item.medicalInsuranceType, ybPropertyList) || '-'
                              }}</span>
                              <span style="width: 80px; display:inline-block">{{ item.spuId }}</span>
                            </el-option>
                          </el-select>
                          <i class="el-icon-plus icon"></i>
                        </div>
                      </div>
                    </div>
                    <!-- 医嘱模块 -->
                    <div ref="adviceSection" class="prescription-advice">
                      <div class="advice-title">医嘱事项</div>
                      <div class="advice-warp">
                        <el-input ref="adviceTextarea" @focus="adviceFocus" class="advice-textarea" autosize
                          type="textarea" v-model="caseForm.doctorAdvice" @input="editAdvice" />
                        <div ref="adviceSelect" v-if="adviceShow" class="advice-select">
                          <div class="adviceList">
                            <div :class="item.isSelect ? 'adviceList-item active' : 'adviceList-item'"
                              @click="selectAdvice(item.doctorAdviceTemplateId, index)"
                              v-for="(item, index) in adviceOption" :key="item.doctorAdviceTemplateId"
                              class="display-f just-b">
                              {{ item.content }}
                              <span v-if="item.isSelect" class="iconfont icon-gou color189 fwb size14"></span>
                            </div>
                          </div>
                          <div class="advice-bottom">
                            <div style="width:48%;" class="advice-close" @click="adviceShow = false">
                              <span class="iconfont icon-guanbi color189 mr5" style="font-size: 12px;"></span>关闭
                            </div>
                            <div @click="setAdviceModal" class="color6671"><span
                                class="iconfont icon-a-Frame626727 color6671 mr5" style="font-size: 12px;"></span>设置模版
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 复诊 -->
                    <div class="repeat-visit">
                      <div class="repeat-visit-content">
                        <div class="repeat-visit-true">
                          <el-checkbox
                            v-model="repeatVisitInfo.revisitFlag"
                            true-label="2"
                            @change="changeRepeatVisitHandle($event,'2')">
                          </el-checkbox>
                          <span>根据病情需要复诊</span>
                        </div>
                        <div class="repeat-visit-true">
                          <el-checkbox
                            v-model="repeatVisitInfo.revisitFlag"
                            true-label="1"
                            @change="changeRepeatVisitHandle($event,'1')">
                          </el-checkbox>
                          <span>请在</span>
                          <div class="date-content">
                            <div class="date-content-val" :class="{'gray': repeatVisitInfo.dateVal === '' }">{{ repeatVisitInfo.dateVal || '日期' }}</div>
                            <div class="date-content-date">
                              <el-date-picker
                                v-model="repeatVisitInfo.dateVal"
                                style="width: 120px;opacity: 0"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期"
                                :clearable="false"
                                :picker-options="repeatVisitInfo.pickerOptions"
                                @change="changeRepeatVisitDateHandle"
                              >
                              </el-date-picker>
                            </div>
                          </div>
                          <span>复诊</span>
                        </div>
                        <div class="repeat-visit-false">
                          <el-checkbox
                            v-model="repeatVisitInfo.revisitFlag"
                            true-label="0"
                            @change="changeRepeatVisitHandle($event,'0')">
                          </el-checkbox>
                          <span>无需复诊</span>
                        </div>
                      </div>
                      <div class="remark">
                        <el-popover
                          popper-class="diagnosePop remark"
                          placement="bottom-start"
                          width="300"
                          trigger="manual"
                          v-model="repeatVisitInfo.remarkInfo.showRemark"
                        >
                          <div class="list">
                            <div class="list-item" v-for="item in repeatVisitInfo.remarkInfo.remarkList" @click="setRemarkHandle(item)">{{ item }}</div>
                          </div>
                          <input
                            slot="reference"
                            type="text"
                            class="remark-input"
                            v-model="repeatVisitInfo.remarkInfo.remark"
                            maxlength="100"
                            placeholder="备注"
                            @input="inputRemarkHandle"
                            @click.stop="searchRemarkHandle"
                          />
                        </el-popover>
                      </div>
                    </div>
                    <div class="right_main_reserve"></div>
                  </div>
                </div>
                <div class="btns">
                  <custom-button :loading="uploading" type="info"
                    @click="dialogVisible('additionalPrescriptionDialog')">取消</custom-button>
                  <custom-button :loading="uploading" type="primary" @click="confirm">确定</custom-button>
                </div>
              </div>
            </div>
          </div>
          <div slot="footer"></div>
        </custom-dialog>
        <custom-dialog width="500px" title="相反/相畏药材签名确认" :showClose="false" v-if="effectsShow" :visible="effectsShow"
          @close="effectsShow = false; loading = false; effectsLoading = false;">
          <p slot="header" class="effect-tips">请务必双签确认含相反相畏的处方！</p>
          <div class="signbox" v-loading="effectsLoading" slot="content">
            <div class="signbox-content">
              <div v-for="(val, ind) in effectsDrugs" :key="ind">
                <div class="drug-title color1F23 size14 font500">中药处方{{ ((val.orderCaseProjectRecipeId || 0) * 1) + 1 }}
                </div>
                <div class="item">
                  <div class="item-drug" v-for="item in val.sideEffects" :key="item.sideEffectsId">
                    <div>
                      <span>{{ item.drugNameOne }}</span> 和 <span>{{ item.drugNameTwo }}</span> {{ item.type == '0' ?
                      '相反' :
                      '相畏' }}
                    </div>
                    <label>{{ doctorInfo.doctorName[0] }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="dialog-footer">
              <span slot="footer">
                <el-button @click="effectsShow = false; effectsLoading = false; loading = false">取 消</el-button>
                <el-button type="primary" @click="doctorSign">确 定</el-button>
              </span>
            </div>
          </div>
          <div slot="footer"></div>
        </custom-dialog>
        <custom-dialog width="690px" title="设置医嘱模版" v-if="adviceDialogShow" :visible="adviceDialogShow"
          @close="adviceDialogShow = false">
          <div slot="content">
            <adviceDialog v-if="adviceDialogShow" :doctorInfo="dialogObj.doctorInfo" @cancel="cancel"></adviceDialog>
          </div>
          <div slot="footer"></div>
        </custom-dialog>
        <custom-dialog width="980px" title="处方模版" v-if="templateShow" :visible="templateShow"
          @close="templateShow = false">
          <div slot="content">
            <prescriptionTemplateDialog @recipeInfoBack="recipeInfoBack" @cancel="templateShow = false">
            </prescriptionTemplateDialog>
          </div>
          <div slot="footer"></div>
        </custom-dialog>
        <custom-dialog width="480px" title="医联产品" v-if="comboShow" :visible="comboShow" @close="comboShow = false">
          <div slot="content">
            <comboTemplate @comboInfoBack="comboInfoBack" @cancel="comboShow = false">
            </comboTemplate>
          </div>
          <div slot="footer"></div>
        </custom-dialog>
        <custom-dialog width="400px" title="上传方式" v-if="uploadShow" :visible="uploadShow" @close="uploadShow = false">
          <div slot="content">
            <uploadDialog :source='2' :orderId="dialogObj.orderId" @localUpload="localUpload"
              @uploadCompany="uploadCompany">
            </uploadDialog>
          </div>
        </custom-dialog>
        <Upload ref="uploadImage" @on-success="handleImgSuccess" @isLoading="isUpload" accept=".png,.jpg,.jpeg"
          class="mr8">
        </Upload>
        <acupoint-dialog v-if="acupointDialogShow" :dialogVisible="acupointDialogShow" @close="acupointDialogClose"
          @accupointConfirm="accupointConfirm" :acupointDialogObj="acupointDialogObj" :tabIndex = acupointDialogObj.tabIndex
          :chooseList="chooseList"></acupoint-dialog>
        <addIngredient class="ingredient_dialog" ref="addIngredient" @useIngredient="useIngredient"></addIngredient>
        <ComboSelect ref="comboSelect" :doctorId="dialogObj.doctorInfo.doctorId" :source="3" @submit="submitComboSelect"></ComboSelect>
      </div>
    </template>

<script>
import adviceDialog from '../../DoctorWorkstation/newDiagnosis/adviceDialog/index.vue'
import CustomDialog from '@/components/customDialog/CustomDialog'
import CustomInput from '@/components/CustomInput'
import CustomSelect from '@/components/CustomSelect'
import { meetDiagnose } from "@/api/history"; // 病历请求
import { isNull, isObject, debounce, isEmptyArray, msgboxWarning, isNullObj, validParams, dictText, deepClone } from '@/utils/validateBase'
import { drugDTO, prescriptionDTO, patientDTO } from '@/DTO/index'
import { Utils } from '@/utils/utils'
import { DRUG_TYPE, doseOptions, remarkOptions, drugMethodOptions, frequencyOptions, takingDosageOptions, takeDaysOptions, applicationTimeOptions, soakTimeOptions, takeAmountFOptions, takeAmountGOptions, takeAmountWOptions, handlingOptions, doseCanChooseList, doseCanChooseKeys } from '@/utils/const'
import { saveOrderApi,getOftenDecoction } from '@/api/outpatientDetail'
import { computeRecipesTotal, computeWeight } from '@/utils/computePrice'
import { quickPrescriptionApi } from '@/api/patient'
import { adviceList } from "@/api/advice"; // 医嘱请求
import { deliveryDTO } from '@/DTO/index'
import { positiveInteger, positiveNum } from '@/utils/regexp'
import prescriptionTemplateDialog from '@/views/DoctorWorkstation/newDiagnosis/prescriptionTemplateDialog/index'
import { Outpatient, Common } from '@/views/DoctorWorkstation/newDiagnosis/data/index'
import { ybCenterDrugDirectoryCategorySignList, ybPropertyList } from '@/utils/const';
import { imgArr } from '@/assets/images/img'
import comboTemplate from './comboTemplate'
import SelectPanel from '@/components/SelectPanel.vue'
import uploadDialog from '@/views/DoctorWorkstation/newDiagnosis/uploadDialog/index'
import Upload from '@/components/Upload/Upload.vue'
import { uploadTemporaryFile } from "@/api/post"; // 科室请求
import { acupointList } from "@/api/acupoint"; // 穴位请求
import { getPhysioIntervalEnum ,physioListDetails,checkPhysioConfig } from "@/api/physio"; // 理疗请求
import acupointDialog from "@/views/DoctorWorkstation/newDiagnosis/component/acupointDialog.vue";
import addIngredient from '@/views/DoctorWorkstation/newDiagnosis/component/addIngredient'
import ActivityProject from '@/views/DoctorWorkstation/newDiagnosis/activityProject/ActivityProject.vue'
import ComboSelect from '@/components/campaign/comboSelect'
import defaultUsageConfigDialog from "@/views/DoctorWorkstation/newDiagnosis/component/defaultUsageConfigDialog.vue";
import { getDict } from "@/api/common";
export default {
  // 定义引入的组件
  components: { CustomDialog, CustomInput, CustomSelect, adviceDialog, prescriptionTemplateDialog, comboTemplate, SelectPanel, uploadDialog, Upload,acupointDialog ,addIngredient, ActivityProject, ComboSelect,defaultUsageConfigDialog},
  props: {
    visibleObj: {
      type: Object,
      default: () => { return {} }
    },
    dialogObj: {
      type: Object,
      default: () => { return {} }
    },
  },
  data() {
    return {
      deptId: this.$session.get('deptId'),
      starImgMap: {
        starOn: require('@/assets/images/star_on.png'),
        starOff: require('@/assets/images/star_off.png')
      },
      imgArr: imgArr,
      recipeContinueObj:{},
      adviceShow: false,//医嘱下拉框显示
      doctorInfo: {},//医生信息
      effectsShow: false,//相反弹框
      effectsLoading: false, // 相反相畏签名确认弹窗loading
      templateShow: false,//模版弹框
      effectsDrugs: [], // 相反、相畏
      excessDrugs: [], // 超量数组
      names: [], // 所有相反、相畏、超量药品名字
      caseForm: {
        patientTell: "",//主诉，
        dialectical: "",//辨证，
        doctorAdvice: '',//医嘱事项
      },//病历信息
      diagnosIds: [],
      diagnosisList: [],//诊断列表
      goodsOption: [],//药品列表
      recipesList: [],//处方列表
      actList: [],//套餐列表
      drugSearchValue: '',//搜索框
      doseOptions: doseOptions,//剂量列表
      remarkOptions: remarkOptions,//备注
      drugMethodOptions: drugMethodOptions,// 使用方式
      frequencyOptions: frequencyOptions,// 服用频次
      takingDosageOptions: takingDosageOptions,// 服用频次
      takeDaysOptions: takeDaysOptions,//服用多少天
      applicationTimeOptions: applicationTimeOptions,//贴敷时间
      soakTimeOptions: soakTimeOptions,//泡浴时间
      takeAmountFOptions: takeAmountFOptions,//打粉每次服用好多g
      takeAmountGOptions: takeAmountGOptions,//制膏每次服用多少
      takeAmountWOptions: takeAmountWOptions,//制丸每次服用多少
      handlingOptions: handlingOptions,
      selectConfig: {
        label: 'item',
        value: 'item',
        text: 'item'
      },
      doseCanChoose: doseCanChooseList,
      DrugNote: {//中药处方事项
        recipeMoment: '饭后服用',//服用时机
        frequency: '1日3次',
        takingDosage: '每次200ml',
        takingDays: '服用10天',
        applicationTime: '约敷5分钟',
        wrapTime: '约泡20分钟',
        bakingPowderDosage: '每次10g',
        creamDosage: '每次20g',
        pelletizingDosage: '每次10g',
        mixingBagNum: '1',//冲服
        doseFrequency: '1日1剂'
      },
      physioOption: [],//理疗列表
      otherOption: [],//其他商品
      chineseMedicineOption: [],//中成药
      adviceSelectList: [],//选中的医嘱
      adviceOption: [],//所有医嘱列表
      adviceDialogShow: false,//处方模版弹框
      recipeList: DRUG_TYPE,//药品类别列表
      imgLsit: [],//图片
      ybCenterDrugDirectoryCategorySignList: ybCenterDrugDirectoryCategorySignList,
      url: '',
      ybCenterDrugDirectoryCategorySignList: ybCenterDrugDirectoryCategorySignList,
      handlingItem: '',
      continueDoseNum: '',//续方剂量
      comboShow: false,//医联弹框显示
      chooseAdviceList: [],//选择的医嘱
      adviceLength: 0,//医嘱条数
      drugOftenUsageList: [],
      uploadShow: false,//上传图片弹框
      uploading: false,
      deg: 0,
      loading: false,
      ybPropertyList: ybPropertyList,
      acupointName: '',
      acupointType: [
        { label: '单', value: 10 },
        { label: '双', value: 20 },
        { label: '左', value: 30 },
        { label: '右', value: 40 },
      ],
      physioIntervalEnum: [],
      physioIntervalEnumOption: [],
      acupointDialogShow: false,
      acupointDialogObj: {},
      alreadyAdd: '',//是否添加过
      speciesTypeTips:'',
      focusAcupoint:{},//当前聚焦的穴位信息
      acupointOptions: [],//穴位列表
      chooseList:[],
      SiFenLeft:[
        { label: '四缝1', value: '1-1' },
        { label: '四缝2', value: '1-2' },
        { label: '四缝3', value: '1-3' },
        { label: '四缝4', value: '1-4' },
      ],
      SiFenRight:[
        { label: '四缝1', value: '2-1' },
        { label: '四缝2', value: '2-2' },
        { label: '四缝3', value: '2-3' },
        { label: '四缝4', value: '2-4' },
      ],
      AshiPoints:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
      
      // 复诊
      repeatVisitInfo: {
        revisitFlag:'',
        dateVal: '',
        remarkInfo: {
          showRemark: false,
          remark: '', // 复诊备注
          remarkList: ['若症状痊愈，则无需复诊'],
          remarkResultList: [],
        },
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < (Date.now() - 3600 * 1000 * 24)
          },
          shortcuts: [{
            text: '三天后',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 3)
              picker.$emit('pick', date)
            }
          }, {
            text: '一周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }, {
            text: '两周后',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 14)
              picker.$emit('pick', date)
            }
          }, {
            text: '三周后',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 21)
              picker.$emit('pick', date)
            }
          }, {
            text: '30天后',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30)
              picker.$emit('pick', date)
            }
          }, {
            text: '90天后',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 90)
              picker.$emit('pick', date)
            }
          }]
        },
      },
      dictData: {
        useFrequency: [],
        singleDoseUnit: [],
        takingTime: [],
        intervalRequirement: [],
      },
    }
  },
  //变量监听
  watch: {},
  filters: {
    filterPerUnit(val) {
      return isNull(val) ? '穴位/部位' : (val == 10 ? '穴位' : '部位')
    },
    filterPerUnitShow(val) {
      return isNull(val) ? '已选' : (val == 10 ? '穴位' : '部位')
    }
  },
  computed: {
    //处理处方数据
    computedRecipes() {
      let that = this
      return function (type) {
        return this.recipesList.filter(item => { return item.recipeType == type })
      }
    },
    computedDrugNoteList() {
      return function (v) {
        let matchKey = v.recipeMethod
        if (this.doseCanChoose.findIndex(v => v.name === matchKey) === -1) {
          matchKey = '煎服'
        }
        let option = this.doseCanChoose.find(v => v.name === matchKey) || { label: [] }
        return option.label
      }
    },
    computedDictText() {
      return function (value, list) {
        return dictText(value, list)
      }
    },
    //计算库存不足和禁用的医联明细
    computedComboItem() {
      return function (items, doseNum) {
        let arr = []
        if (!isEmptyArray(items) && !isNull(items)) {
          items.forEach(i => {
            if (i.onSale == '0' || Utils.gt(this.$bigNumber(i.itemNum, '*', doseNum || 1), i.inventory) || i.isShow) {
              arr.push(i)
            }
          })
        }
        return arr
      }
    },
    //乘法
    computedMultiplication() {
      let that = this
      return function (a, b) {
        return Number(this.$bigNumber(isNull(a) ? 1 : a, '*', isNull(b) ? 1 : b))
      }
    },
    //计算图片index
    computedImgIndex() {
      return this.imgLsit.findIndex(v => { return v == this.url })
    },
    computedAcupointType() {
      let that = this;
      return function (type,typeExtend) {
        if(type == 50){
          return typeExtend[0]
        }else if( type == 60){
          return isNull(typeExtend) ? 0 : typeExtend.length
        }else{
          return dictText(type, that.acupointType)
        }
      }
    },
    computedPerUnitCount() {
      return function (physioExtendJson) {
        let num = 0
        let { acupointinfoList, perUnit } = physioExtendJson
        if (isNull(perUnit)) {
          acupointinfoList.forEach(v => {
            if(v.type == 60){
              num = num + Number((isNull(v.typeExtend) ? 0 :v.typeExtend.length))
            }else if(v.type == 50){
              num =  num + Number((isNull(v.typeExtend) ? 0 : v.typeExtend[0]))
            }else if(v.type == 20){
              num = num + 2;
            }else{
              num = num + 1
            }
          })
        } else {
          acupointinfoList.forEach(v => {
            if (v.speciesType == perUnit) {
              if(v.type == 60){
                num = num + Number((isNull(v.typeExtend) ? 0 :v.typeExtend.length))
              }else if(v.type == 50){
                num =  num + Number((isNull(v.typeExtend) ? 0 : v.typeExtend[0]))
              }else if(v.type == 20){
                num = num + 2;
              }else{
                num = num + 1
              }
            }
          })
        }
        return num
      }
    },
    computedShowTips(){
      return function (physioExtendJson) {
        return isNull(physioExtendJson.perUnit) ? false: physioExtendJson.acupointinfoList.some(v => v.speciesType != physioExtendJson.perUnit)
      }
    },
     computeYbScope(){
      return function(val){ 
        if(val == 1){
          return '可统筹'
        }else if(val == 2){
          return '仅个账'
        }else{
          return '不可刷医保'
        }
      }
    },
    computedIngredients(){
      return function(ingredientsTemplateDetails){
        let res =  ingredientsTemplateDetails.map(v2 => {
          let str = `${v2.oriName}${v2.oriNum}${v2.oriUnit}`;
          if (v2.oriHandling) {
            str += v2.oriHandling;
          }
          return str;
        }).join('，');
        return res
      }
    },
    otherProjectList () {
      return (list) => {
        return list.filter(v => { return v.commodityType !== 1 })
      }
    }
  },
  // 页面初始化
  async created() {
    let { recipesList, doctorInfo, orderInfo, patientInfo, deliveryObj } = this.dialogObj
    this.doctorInfo = doctorInfo
    this.deliveryObj = deliveryObj
    this.orderInfo = orderInfo
    this.patientInfo = patientInfo
    let orderType = orderInfo.orderType
    if (!isNull(orderType) && orderType == '13') {
      this.getRecipeContinue()
    }
    if (orderType != 13) {
      this.getPrecreiptionImg()
    }
    this.getDetail()
    this.getAdviceList()
    this.getPhysioIntervalEnum()
    this.getDictData()
  },
  // 页面DOM加载完成
  mounted() {
    // 在挂载时将事件监听器添加到文档上
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    // 在卸载组件之前删除事件监听器
    document.removeEventListener("click", this.handleClickOutside);
  },

  // 页面方法
  methods: {

    /**
     * 获取续方信息
     */
    async getRecipeContinue() {
      let { code, data } = await prescriptionDTO.getRecipeContinue({ orderId: this.dialogObj.orderId })
      if (code == 200) {
        if (!isNull(data.images)) {
          this.imgLsit = data.images.split(',');
          this.url = this.imgLsit[0]
          this.continueDoseNum = data.doseNum
          this.recipeContinueObj = data
        }
      }
    },

    adviceFocus () {
      this.adviceShow = true

      this.$nextTick(() => {
        const adviceSection = this.$refs.adviceSection
        adviceSection.scrollIntoView({ behavior: 'smooth' })
      })
    },

    /**
   * 选择医嘱
   */
    //编辑医嘱
    editAdvice: _.debounce(function (e) {
      this.chooseAdviceList = [];
      this.adviceSelectList = [];
      this.adviceOption.forEach((val, ind) => {
        this.adviceOption[ind].isSelect = false;
      })
      if (e != '') {
        let eSpl = e.split('\n')
        let neweSpl = eSpl.filter(val => val != '')
        // 替换所有的序号
        let reg = /\d+\./g
        neweSpl = _.flattenDeep(neweSpl.map(i => (i.substring(0,5).replace(reg,'')+i.substring(5))));
        neweSpl = neweSpl.filter(val => val != '')
        neweSpl = neweSpl.map((k, ind) => (ind + 1) + '.' + k)
        let obj = {
          content: neweSpl.join('\n'),
          delFlag: "0",
          doctorAdviceTemplateId: 'own'
        }
        this.chooseAdviceList = [obj]
        if (neweSpl.length != this.adviceLength) this.handleAdvice()
      }
    }, 100),
    //处理展示的advice
    handleAdvice() {
      // 如果为空或者不是数组返回
      if (_.isEmpty(this.chooseAdviceList) && !_.isArray(this.chooseAdviceList)) return;
      //替换所有的换行
      let contentList = this.chooseAdviceList.map(val => (val.content.split(/\r/g) && val.content.split(/\n/g)));
      // console.log('1111',contentList[0])
      contentList=_.flattenDeep(contentList);
      let  contentListNew = contentList.filter(val => val != '')
      //替换所有的序号
      let reg = /\d+\./g
      contentListNew = _.flattenDeep(contentListNew.map(i => (i.substring(0,5).replace(reg,'')+i.substring(5))))
      // contentList = contentList.filter(val => val != '')
      contentListNew = contentListNew.map((k, ind) => (ind + 1) + '.' + k);
      this.adviceLength = contentListNew.length
      let name = contentListNew.join('\n');
      this.$set(this.caseForm, 'doctorAdvice', name)
    },
    /**
     * 选择医嘱
     */
    selectAdvice(id, selectIndex) {
      if (!this.adviceSelectList.includes(id)) {
        this.adviceSelectList.push(id)
        this.adviceOption[selectIndex].isSelect = true
        this.chooseAdviceList = this.chooseAdviceList.concat([this.adviceOption[selectIndex]])
      } else {
        this.adviceOption[selectIndex].isSelect = false
        this.adviceSelectList = this.adviceSelectList.filter(val => val != id)
        this.chooseAdviceList = this.chooseAdviceList.filter(val => val.doctorAdviceTemplateId != id)
      }
      this.handleAdvice()
    },

    /**
    * 获取医嘱列表
    */
    getAdviceList() {
      adviceList({ deptId: this.$session.get('deptId'), doctorId: this.dialogObj.doctorInfo.doctorId }).then(res => {
        let { code, rows } = res
        if (code == 200) {
          rows.forEach(item => {
            item.isSelect = false //是否选中
          })
          this.adviceOption = rows
        }
      })
    },

    /**
     * 商品数量enter键触发
     */
    numberEnter(index) {
      this.$refs[`select${index}`][0].focus()
    },
    /**
     * 输入框聚焦触发
     */
    numberFocus(index, itemIndex) {
      this.hasChildWithClassName()
      this.selectEffect(index, itemIndex)
    },
    /**
     * 商品数量上下键触发
     * item 处方数据
     * itemIndex 商品索引
     * type down上键 up下键
     */
    numberInputMove(index, item, itemIndex, type) {
      // this.$refs[`pro-item${index}${itemIndex}`][0].classList.remove('pro-item-active')
      this.hasChildWithClassName()
      let items = item.items
      if (type == 'down') {
        if (Utils.eq(itemIndex, items.length - 1)) return
        itemIndex = this.$bigNumber(itemIndex, '+', 1);
      } else if (type == 'up') {
        if (Utils.eq(itemIndex, 0)) return
        itemIndex = this.$bigNumber(itemIndex, '-', 1);
      }
      let itemId = items[itemIndex].itemId
      this.$nextTick(() => {
        this.$refs[`${index}num${itemId}`][0].$children[0].focus()
        this.$refs[`${index}num${itemId}`][0].$children[0].select()
        // this.$refs[`pro-item${index}${itemIndex}`][0].classList.add('pro-item-active')
        this.selectEffect(index, itemIndex)
      })

    },

    /**
     * 获取处方和病历信息
     */
     getDetail() {
      prescriptionDTO.getOutpatientDetailApi({ orderId: this.dialogObj.orderId }).then(res => {
        let { code, data } = res
        if (code == 200) {
          this.recipesList = data.projectRecipes
          this.actList = data.actGroups || []
          this.computeRecipesTotal()
          let otherArr = data.projectRecipes.filter(item => { return item.recipeType == '0' })
          if (isEmptyArray(data.projectRecipes) || isEmptyArray(otherArr)) {
            this.recipesList.push({
              orderId: this.dialogObj.orderId,
              recipeSourceType: '2',
              projectType: '1',
              recipeType: '0',
              items: []
            })
          }
        }
      })
      patientDTO.getCaseDiagnosis({ orderId: this.dialogObj.orderId }).then(res => {
        let { code, data } = res
        if (code == 200) {
          if (isNull(data)) {
            // 新增的零售开单，详情接口返回的数据为null
            this.caseForm = {
              orderId: this.dialogObj.orderId,
              patientTell: "",//主诉，
              dialectical: "",
            }
            // 如果是图片需方，则默认为不复诊
            if (this.orderInfo.orderType && this.orderInfo.orderType == '13') {
              this.repeatVisitInfo.revisitFlag = '0'
            } else {
              this.repeatVisitInfo.revisitFlag = '2'
            }
          } else {
            this.caseForm = data
            let formatDiagnosis = data.diagnosisList.map(val => { return { code: val.diagnoseCode, name: val.diagnoseName,ybScope:val.ybScope } })
            this.diagnosIds = formatDiagnosis;
            this.diagnosisList = formatDiagnosis
            if (!isNull(data.doctorAdvice)) {
              let arr = data.doctorAdvice.split('\n')
              if (_.isEmpty(arr)) return
              arr && arr.map(v => {
                this.chooseAdviceList.push(
                  {
                    content: v,
                    delFlag: "0",
                    doctorAdviceTemplateId: 'own0'

                  }
                )
              })
              this.handleAdvice()
            }
            this.repeatVisitInfo.revisitFlag = isNull(data.revisitFlag) ? '2' : data.revisitFlag
            this.repeatVisitInfo.dateVal = data.revisitFlag == '1' ? (data.revisitTime || '') : ''
            this.repeatVisitInfo.remarkInfo.remark = data.revisitNotes || ''
          }

        }
      })
    },

    /**
     * 校验数量
     */
    updateDataNum(val, obj) {
      obj.isShow = true
      let bol = validParams(val, positiveNum, '请输入数字,保留两位小数')
      if (!bol) {
        obj.itemNum = ''
      }
      this.$forceUpdate()
    },
    /**
     * 校验正整数
     * type 1剂量 2数量
     */
    updateDataInteger(val, obj, type) {
      if (isNull(val)) return
      let bol = validParams(val, positiveInteger, '请输入正整数')
      if (!bol) {
        if (type == '1') {
          obj.doseNum = 1
        } else if (type == '2') { obj.itemNum = 1 }
      }
      this.$forceUpdate()
    },
    /**
     * 计算处方总价
     */
    computeRecipesTotal() {
      computeRecipesTotal(this.recipesList, this)
      computeWeight(this.recipesList, this)
      this.$forceUpdate()
    },
    /**
     * 添加理疗处方
     */
    addPhysio() {
      this.recipesList.push({
        orderId: this.dialogObj.orderId,
        // recipeSourceType: this.orderInfo.status == '8' && this.orderInfo.replenishRecipel == '2' ? '2' : '1',
        recipeSourceType: this.orderInfo.status == '8' ? '2' : '1',
        projectType: '0',
        recipeType: '3',
        remark: '',
        totalPrice: 0,
        items: [],
      })
    },
    /**
     * 添加理疗处方
     */
    addChineseMedicine() {
      this.recipesList.push({
        orderId: this.dialogObj.orderId,
        // recipeSourceType: this.orderInfo.status == '8' && this.orderInfo.replenishRecipel == '2' ? '2' : '1',
        recipeSourceType: this.orderInfo.status == '8' ? '2' : '1',
        projectType: '0',
        recipeType: '4',
        remark: '',
        totalPrice: 0,
        items: [],
      })
    },
    /**
     * 添加中药处方
     */
    addDrug() {
      let obj = {
        orderId: this.dialogObj.orderId,
        recipeSourceType: this.orderInfo.status == '8' ? '2' : '1',
        // recipeSourceType: this.orderInfo.status == '8' && this.orderInfo.replenishRecipel == '2' ? '2' : '1',
        projectType: '0',//0处方项目
        recipeType: '1',//中药处方
        doseNum: 1,//
        doseType: '0',//颗粒，饮片，全部
        recipeMethod: '煎服',//煎法
        recipeMoment: '',//服用时机
        frequency: '',
        isYlcp: '0',
        takingDosage: '',
        takingDays: '',
        applicationTime: '',
        wrapTime: '',
        bakingPowderDosage: '',
        creamDosage: '',
        pelletizingDosage: '',
        doseFrequency: '',
        mixingBagNum: '1',//冲服
        weight: 0,//药品总重
        processFlag: '0',//是否加工
        remark: '',
        process: {//加工信息
          processName: '',
          processPrice: '',
          bagNum: '',
          remark: '',
          processingValue: "[]"
        },
        ingredients:[]
      }
      obj = this.matchOftenUsageList(obj.recipeMethod, obj)
      obj.items = []
      this.recipesList.push(obj)
    },
    /**
    * 关闭
    */
    dialogVisible(name) {
      this.$emit("close", name);
    },
    /**
    * 查询诊断
    */
    meetDiagnose: debounce(function (val) {
      this.diagnosisList = []
      if (!isNull(val)) {
        meetDiagnose({ search: val, pageNum: 1, pageSize: 30 }).then(res => {
          if (res.code == 200) {
            this.diagnosisList = [...this.diagnosisList, ...res.rows]
          }
        })
      }
    }, 300),
    /**
     * 选择诊断
     */
    diagnosChange(e) {
      this.$refs.diagnoseSelect.query = ''
      let arr = []
      e.forEach(item => {
        if (isObject(item)) {
          arr.push({
            diagnoseCode: item.code,
            diagnoseName: item.name,
            ybScope:item.ybScope
          })
        } else {
          arr.push({
            diagnoseCode: '',
            diagnoseName: item,
            ybScope:'3'
          })
        }
      })
      this.caseForm.diagnosisList = arr
    },
    /**
     * 搜索中药
     */
    async getDrug(query, type) {
      let typeStr = ''
      switch (type) {
        case '0':
          typeStr = '中药饮片';
          break;
        case '1':
          typeStr = '中药颗粒';
          break;
        case '2':
          typeStr = null;
          break;
      }
      if (isNull(query)) return
      let params = {
        types: type == 2 ? ['0', '1'] : [type],
        searchWord: query,
        deptId: this.$session.get('deptId'),
        recipeType:'1'
      }
      this.goodsOption = await drugDTO.getOtherProject(params);
      this.drugSearchValue = ''
    },
    /**
     * 获取理疗
     */
    getPhysioList:debounce(function (query) { 
       Outpatient.getOtherProject({deptId:this.$session.get('deptId'), searchWord: query, types: ['3'],recipeType:3,doctorId:this.dialogObj.doctorInfo.doctorId}).then(res => {
          if (_.isEmpty(res)) {
              this.physioOption = []
          } else {
              this.physioOption = res
          }
      })
    }, 200),
    /**
     * 获取其他商品
     */
    async getOther(query) {
      if (isNull(query)) return
      this.otherOption = await drugDTO.getOtherProject({ searchWord: query,deptId:this.$session.get('deptId'),recipeType:0 });
    },
    /**
     * 获取中成药商品
     */
    async getChineseMedicien(query) {
      if (isNull(query)) return
      this.chineseMedicineOption = await drugDTO.getOtherProject({ searchWord: query, types: ['3'],deptId:this.$session.get('deptId'),recipeType:4 });
    },
    /**
     * 选择中药商品
     * val 选择的id obj每项处方 type 0其他 1中药 3理疗 4 中成药
     */
    async selectGoodsItem(val, obj, type, index) {
      this.hasChildWithClassName()
      if (isNull(val)) return
      let goodsItem = isNull(obj.items) ? [] : obj.items
      let selectName = ''
      switch(type){
        case '0':
        selectName = this.otherOption.find(item => { return item.itemId == val }).itemName
        break;
        case '1':
        selectName = this.goodsOption.find(item => { return item.itemId == val }).itemName
        break;
        case '4':
        selectName = this.chineseMedicineOption.find(item => { return item.itemId == val }).itemName
        break;
      }
      let itemIndex = goodsItem.findIndex(item => { return item.itemId == val || item.itemName == selectName })
      if (Utils.gt(itemIndex, -1)) {
        this.$message.error('您已添加过该商品')
        this.drugSearchValue = ''
        return
      }
      let goodIndex = ''
      let item = ''
      switch (type) {
        case '0':
          goodIndex = this.otherOption.findIndex(item => { return item.itemId == val })
          item = this.otherOption[goodIndex]
          break;
        case '1':
          goodIndex = this.goodsOption.findIndex(item => { return item.itemId == val })
          item = this.goodsOption[goodIndex]
          item.handling = ''
          item.isOwned = '0'
          break;
        case '3':
          goodIndex = this.physioOption.findIndex(item => { return item.itemId == val })
          item = this.physioOption[goodIndex]
          item.itemNum =item.executionMode == 20 ? this.$bigNumber(3, '*', 1) : 1
          if(item.effectDrugPriceConfig && item.effectDrugPriceConfig.configType == 1){
            item.price = item.effectDrugPriceConfig.fixedPrice
          }else if(item.effectDrugPriceConfig && item.effectDrugPriceConfig.configType == 2){
            let config = this.findPriceRange(item.itemNum,item.effectDrugPriceConfig.ladderPriceConfigs)
            item.price = isNull(config) ? item.price : config.ladderPrice
          }
          let physioExtendJson = {}
          physioExtendJson.perUnit = item.perUnit
          physioExtendJson.perUnitCount = item.perUnitCount
          physioExtendJson.executionMode = item.executionMode
          physioExtendJson.soldNum = 1
          physioExtendJson.onlyNum = item.executionMode == 20 ? 3 : null
          physioExtendJson.physioIntervalEnum = null
          physioExtendJson.acupointinfoList = []
          goodsItem.push({
            ...item,
            physioExtendJson:physioExtendJson,
            executeCount:null,
            executeInterval:null,
            executeDesc:null,
          })
          let physioIndex = goodsItem.length-1
          this.$nextTick(() => {
            this.$refs[`search${index}${physioIndex}`][0].focus()
          })
          break;
        case '4':
          goodIndex = this.chineseMedicineOption.findIndex(item => { return item.itemId == val })
          item = this.chineseMedicineOption[goodIndex]
          let { code,data } = await getOftenDecoction({ spuId: item.itemId })
          if (code === 200 && data) {
             goodsItem.push({
              ...item,
              itemNum: 1, totalPrice: item.price, remark: '',
              useFrequency:data.useFrequency,
              singleDose:data.singleDose,
              singleDoseUnit:data.singleDoseUnit,
              takingTime:data.takingTime,
              intervalRequirement:data.intervalRequirement,
            })
          }else{
             goodsItem.push({
              ...item,
              itemNum: 1, totalPrice: item.price, remark: '',
              useFrequency:'106',singleDose:'',singleDoseUnit: '',takingTime:'117',intervalRequirement:'',
            })
          }
         
          break;

      }
      if(type !=3 && type !=4){
        goodsItem.push({
        ...item,
        itemNum: 1, totalPrice: item.price, remark: ''
        })
        this.$nextTick(() => {
          this.$refs[`${index}num${val}`][0].$children[0].focus()
          this.$refs[`${index}num${val}`][0].$children[0].select()
          this.selectEffect(index, goodsItem.length - 1)
        })
      }
      this.drugSearchValue = ''
      this.goodsOption = [];
      this.otherOption = []
      this.computeRecipesTotal()
    },

    /**
     * 删除商品
     * item 处方信息 index商品索引
     */
    delItem(item, itemId) {
      let index = item.items.findIndex(obj => { return obj.itemId == itemId })
      if (index == -1) return
      item.items.splice(index, 1)
      this.computeRecipesTotal()
    },
    /**
     * 删除处方
     */
    delPrescription(index, orderCaseProjectRecipeId) {
      if (isNull(orderCaseProjectRecipeId)) {
        this.recipesList.splice(index, 1)
      } else {
        prescriptionDTO.removePrescription({ orderCaseProjectRecipeId }).then(res => {
          if (res.code == 200) this.recipesList.splice(index, 1)
        })
      }
    },

    /**
    * 保存就诊信息
    * orderId 就诊id
    * flag 是否为补录
    */
    saveVisiting() {
      return new Promise((resolve, reject) => {
        // orderType就诊类型：0-门诊就诊，4-零售开单，5-网诊就诊，12-续方就诊
        let parmas = { ...this.patientInfo, ...this.doctorInfo, orderId: this.dialogObj.orderId, replenishRecipel: '1', deptId: this.$session.get('deptId'), orderType: '4' }
        let { salesPersonId, salesPerson, salesUserCode } = this.orderInfo
        parmas.salesPersonId = salesPersonId
        parmas.salesPerson = salesPerson
        parmas.salesUserCode = salesUserCode
        if (!isNull(this.registerPrice)) parmas.price = this.dialogObj.registerPrice
        quickPrescriptionApi(parmas).then(async res => {
          if (res.code == 200) {
            let { code, data } = await saveOrderApi({ check: 0, orderId: this.dialogObj.orderId });
            if(code==900001){
              this.loading = false;
            this.effectsLoading = false
            this.effectsShow = false
            }else if (code == 200) {
              this.$message({
                type: 'success',
                message: '保存成功！',
                duration: 1000
              });
              this.loading = false;
              this.$emit("updateData");
            } else {
              this.effectsLoading = false
              this.effectsShow = false
              this.loading = false;
            }
          } else {
            this.loading = false;
            this.effectsLoading = false
            this.effectsShow = false
          }
        })
      })
    },

    /**
     * 确定
     */
     confirm: debounce(async function () {
      if (isNull(this.caseForm.patientTell) || (isNull(this.caseForm.diagnosisList) || isEmptyArray(this.caseForm.diagnosisList))) return this.$message.error('请填写病历信息')
      
      // 校验是否需要复诊
      if (!this.repeatVisitInfo.revisitFlag == '1' && !this.repeatVisitInfo.revisitFlag == '0') {
        return this.$message.error('请选择是否需要复诊')
      }
      // 校验复诊日期
      if (this.repeatVisitInfo.revisitFlag == '1' && !this.repeatVisitInfo.dateVal) {
        return this.$message.error('请选择复诊日期')
      }

      let flag = false
      let doseNumFlag = false
      let emptyFlag = false
      let arr = []
      let phyFlag = false
      let drugList = this.recipesList.filter(item => { return item.recipeType == '1' })
      this.recipesList.forEach((item, index) => {
        if ((item.recipeType == '1' || item.recipeType == '3' || item.recipeType == '4') && isEmptyArray(item.items)) {
          emptyFlag = true;
          return;
        }
        if (item.recipeType == '1' && isNull(item.doseNum)) {
          doseNumFlag = true
          return
        }
        if (item.recipeType == '1') {
          this.handDrugs(item, index)
        }
        if (!isNull(item.items)) {
          item.items && item.items.forEach(obj => {
            if(isNull(obj.itemNum) || obj.itemNum == 0){
              flag = true
              return;
            }
          })
        }
        if (item.recipeType != '0' && isEmptyArray(item.items)) flag = true
        // 理疗校验
        if(item.recipeType == '3'){
          item.items.forEach(obj => {
            if(isNull(obj.executeDesc)){
              phyFlag=true
              this.$message.error('请填写执行频率')
              return;
            }
            if(isNull(obj.itemNum)){
              phyFlag = true
              this.$message.error('请输入理疗项目数量！')
              return;
            }
            if(obj.physioExtendJson && obj.physioExtendJson.perUnitCount ){
              if(this.computedPerUnitCount(obj.physioExtendJson) < (obj.physioExtendJson.executionMode == 10 ? obj.physioExtendJson.perUnitCount : obj.physioExtendJson.perUnitCount * obj.physioExtendJson.onlyNum)){
                phyFlag = true
                this.$message.error('请补全理疗项目的穴位/部位后完诊')
                return;
              }
            }
          })
        }
        //中成药校验
        if(item.recipeType == '4'){
          item.items.forEach(obj => {
            if(isNull(obj.useFrequency)){
              phyFlag=true
              this.$message.error('请选择用药频次')
              return;
            }
            if(isNull(obj.singleDose)){
              phyFlag = true
              this.$message.error('请输入单次用量！')
              return;
            }
            if(isNull(obj.singleDoseUnit)){
              phyFlag=true
              this.$message.error('请选择单次用量单位')
              return;
            }
            if(isNull(obj.takingTime)){
              phyFlag=true
              this.$message.error('请选择服用时间')
              return;
            }
            if(isNull(obj.intervalRequirement)){
              phyFlag=true
              this.$message.error('请选择时间间隔要求')
              return;
            }

          })
        }
      })
      this.actList.forEach(item => {
        item.items.forEach(obj => {
          if(obj.drugType === 1){
            if(isNull(obj.executeDesc)){
              phyFlag=true
              this.$message.error('请填写执行频率')
              return;
            }
            if(isNull(obj.itemNum)){
              phyFlag = true
              this.$message.error('请输入理疗项目数量！')
              return;
            }
            if(obj.physioExtendJson && obj.physioExtendJson.perUnitCount ){
              if(this.computedPerUnitCount(obj.physioExtendJson) < (obj.physioExtendJson.executionMode == 10 ? obj.physioExtendJson.perUnitCount : obj.physioExtendJson.perUnitCount * obj.physioExtendJson.onlyNum)){
                phyFlag = true
                this.$message.error('请补全理疗项目的穴位/部位后完诊')
                return;
              }
            }
          }
        })
      })
      if(phyFlag) return
      if (flag) return this.$message.error('处方项目商品不能为空或数量不能为0')
      if (doseNumFlag) return this.$message.error('处方剂量不能为空')
      // 除图片续方都可上传图片
      this.loading = true
      checkPhysioConfig(this.recipesList).then(res=>{
          if(res.code == 200){
            if (isEmptyArray(drugList)) {
              if (this.orderInfo.orderType && this.orderInfo.orderType == '13') {
                this.picToRecipe()
              } else {
                this.saveOrderCase()
              }
            } else {
                this.checkEffect().then(checkRes => {
                  if (checkRes.code == 200) {
                    if (isEmptyArray(checkRes.data)) {
                      if (this.orderInfo.orderType && this.orderInfo.orderType == '13') {
                        this.picToRecipe()
                      } else {
                        this.saveOrderCase()
                      }
                    } else {
                      this.effectsDrugs = checkRes.data;
                      this.effectsShow = true;
                    }
                  
                  }
                })
            }
          }else{
            this.loading = false;
          }        
      })
    }, 1000, true),

    /**
     * 图片转录
     */
    async picToRecipe() {
      let deliveryParams = {}
      let params = {
        orderId: this.dialogObj.orderId,
        checkEffect: 0,
        items: this.recipesList,
        ...this.caseForm,
        revisitFlag: this.repeatVisitInfo.revisitFlag,
        revisitTime: this.repeatVisitInfo.dateVal || '',
        revisitNotes: this.repeatVisitInfo.remarkInfo.remark || ''
      }
      if (!isNull(this.deliveryObj) && !isNullObj(this.deliveryObj)) {
        let { provinceId, regionId, scopeId, cityId, companyName } = this.deliveryObj
        let doseNum = 0
        let weight = 0
        let drugPrice = 0
        this.recipesList.forEach(item => {
          drugPrice = this.$bigNumber(drugPrice, '+', isNull(item.totalPrice) ? 0 : item.totalPrice)
          doseNum = this.$bigNumber(doseNum, '+', isNull(item.doseNum) ? 0 : item.doseNum)
          weight = this.$bigNumber(weight, '+', this.$bigNumber(isNull(item.weight) ? 0 : item.weight, '*', item.doseNum))
        })
        deliveryParams = {
          provinceId, regionId, scopeId, cityId, doseNumber: doseNum, weight, companyName
        }
      }
      // params.items = params.items.filter(item => { return !(item.recipeType === '0' && item.items.length === 0)})
      let { code, data } = await prescriptionDTO.picToRecipe(params)
      if (code == 200) {
        this.$message({
          type: 'success',
          message: '保存成功！',
          duration: 1000
        });
        this.loading = false;
        if (!isNull(this.deliveryObj) && !isNullObj(this.deliveryObj)) {
          this.getDeliveryPrice(deliveryParams)
        } else {
          this.$emit("updateData");
        }
      } else {
        this.loading = false;
      }
    },
    /**
   * 计算配送价格
   */
    async getDeliveryPrice(params) {
      let { code, data } = await deliveryDTO.getDeliveryPrice(params);
      if (code == 200) {
        if (isNull(data)) {
          this.deliveryObj.price = 0

        } else {
          this.deliveryObj.price = data
        }
        this.$emit("updateData", this.deliveryObj);
      }
    },
    /**
     * 校验相反相畏
     */
    checkEffect() {
      return new Promise((resolve, reject) => {
        let drugList = this.recipesList.filter(item => { return item.recipeType == '1' })
        let pairDrugs = []
        drugList.forEach((item, index) => {
          pairDrugs.push({
            orderCaseProjectRecipeId: index,
            items: item.items
          })

        })
        prescriptionDTO.checkEffect({ pairDrugs }).then(res => {
          resolve(res)
        })
      })
    },

    /**
     * 保存病历
     */
    saveCase() {
      return new Promise((resolve, reject) => {
        patientDTO.editCaseDiagnosis(this.caseForm).then(res => {
          if (res.code == 200) resolve(res.data)
        })
      })
    },
    /**
     * 保存处方信息
     * obj 处方信息
     */
    savePrescription(obj) {
      return new Promise((resolve, reject) => {
        prescriptionDTO.editPrescription(obj).then(res => {
          if (res.code == 200) resolve(res.data)
        })
      })
    },
    /**
     * 完成就诊
     * check是否校验相反
     */
    async saveOrderCase() {
      this.recipesList.forEach(item => {
        if (item.recipeType == '1') {
          let noteList = {
            recipeMoment: '',//服用时机
            frequency: '',
            takingDosage: '',
            takingDays: '',
            applicationTime: '',
            wrapTime: '',
            bakingPowderDosage: '',
            creamDosage: '',
            pelletizingDosage: '',
            doseFrequency: '',
            mixingBagNum: '',//冲服
          }
          // let list = this.doseCanChoose.filter(val => val.name == item.recipeMethod)[0].label.map(k => k.id)
          let arr2 = this.doseCanChoose.filter(val => val.name == item.recipeMethod)
          let list = []
          if (_.isEmpty(arr2)) {
            let doseObj = { name: item.recipeMethod, label: [{ id: 'doseFrequency', kid: doseOptions }, { id: 'frequency', kid: frequencyOptions }, { id: 'takingDosage', kid: takingDosageOptions }, { id: 'recipeMoment', kid: remarkOptions }] }
            list = doseObj.label.map(k => k.id)
          } else {
            list = arr2[0].label.map(k => k.id)
          }
          list.forEach(va => {
            noteList[va] = item[va]
          })
          if (item.recipeMethod == '冲服') {
            noteList.mixingBagNum = item.mixingBagNum
          }
          item = {
            ...item,
            ...noteList
          }
        }
      })
      let obj = {
        orderInfo: {
          revisitFlag: this.repeatVisitInfo.revisitFlag,
          revisitTime: this.repeatVisitInfo.dateVal || '',
          revisitNotes: this.repeatVisitInfo.remarkInfo.remark || ''
        },
        caseDiagnosis: this.caseForm,
        projectRecipes: this.recipesList,
        actGroups: this.actList
      }
      prescriptionDTO.saveDoorDTO(obj).then(res => {
        if (res.code == 200) {
          this.saveVisiting()
        } else {
          this.loading = false;
          this.effectsShow = false;
          this.effectsLoading = false;
        }
      })
    },
    /**
     * 医生签名
     */
    doctorSign() {
      this.effectsLoading = true
      this.saveOrderCase()
    },
    /**
     * 设置处方模版
     */
    setAdviceModal() {
      this.adviceDialogShow = true
    },
    /**
     * 关闭设置处方模版
     */
    cancel() {
      this.adviceDialogShow = false
      this.getAdviceList()
    },
    handleClickOutside(event) {
      // 如果点击的不是目标 DIV 或目标 DIV 的子元素，则隐藏目标 DIV
      if (!isNull(this.$refs.adviceSelect)) {
        if (!this.$refs.adviceSelect.contains(event.target) && !this.$refs.adviceTextarea.$refs.textarea.contains(event.target)) {
          this.adviceShow = false
        }
      }
    },
    /**
   * 药品类型一键转换
   * @param {*} obj 
   */
    typeChange(e, item, index) {
      let pre = this.$refs[`typeSelect` + index][0].value
      if (Utils.gt(item.items.length, 0)) {
        let typeStr = e == '0' ? '中药饮片' : e == '1' ? '中药颗粒' : ''
        msgboxWarning(this, {
          message: `是否将处方中的所有药品转为${typeStr == '' ? '全部' : typeStr}`,
          confirmFn: async () => {
            item.doseType = e
            let { code,data } = await drugDTO.drugTypeConvert({targetType:e,srcType:pre,deptId: this.$session.get('deptId'),drugList:item.items})
            if(code ==200){
              item.items.forEach(v1=>{
                data.unmatchDrugList && data.unmatchDrugList.forEach(v2=>{
                  if(v1.spuId == v2.spuId){
                    v1.onSale = '0'
                    v1.doseType = e
                  }
                })
              })
              item.items.forEach(v1=>{
                data.newDrugList && data.newDrugList.forEach(v2=>{
                  if(v1.spuId == v2.srcSpuId){
                    v1.inventory = Number(v2.inventory),
                    v1.medicalInsuranceType=v2.medicalInsuranceType,
                    v1.price=v2.price, 
                    v1.doseType= v2.firstCategory,
                    v1.itemName= v2.spuCommonName,
                    v1.itemUnit= v2.unit,
                    v1.onSale='1',
                    v1.spuCommonName=v2.spuCommonName,
                    v1.spuId=v2.spuId
                    v1.itemId = v2.spuId
                  }
                })
              })
            }
          },
          cancelFn: () => {
            item.doseType = pre
          },
        });
      }
    },
    nameChange(list, type) {
      if (type == 1) {
        return list.map(kid => {
          return {
            itemId: kid.spuId,
            itemName: kid.spuCommonName,
            spuId: kid.spuId,
            itemNum: kid.number,
            itemUnit: kid.unit,
            price: kid.price,
            inventory: Number(kid.inventory),
            handling: kid.handling,
            deleteShow: false,
            oldDrugName: kid.spuCommonName,
            // onSale: kid.onSale || '0',
            isOwned: isNull(kid.isOwned) ? '0' : kid.isOwned,
          }
        })
      }
      if (type == 2) {
        return list.map(kid => {
          return {
            id: kid.spuId,
            number: kid.itemNum,
            unit: kid.itemUnit,
            price: kid.price,
            inventory: Number(kid.inventory),
            handling: kid.handling,
            deleteShow: false,
            oldDrugName: kid.itemName,
            // onSale: kid.onSale || '0',
            isOwned: isNull(kid.isOwned) ? '0' : kid.isOwned,
          }
        })
      }

    },
    /**
     * 选择药品煎法
     * index 处方索引
     * drugIndex 药品索引
     */
    chooseUsage(val, index, drugIndex) {
      let drugItem = deepClone(this.recipesList)
      drugItem[index].items[drugIndex].handling = val
      this.handDrugs(drugItem[index], index)
    },
    /**
     * 打开模版弹框
     */
    openPrescriptionTemplateDialog() {
      this.templateShow = true
    },
    /**
     * 打开医联弹框
     */
    openComboTemplateDialog() {
      this.comboShow = true
    },
    /**
    * 使用处方模版
    */
    recipeInfoBack(val) {
      val.type=='0' ? this.useRecipeDrugDemo(val) : this.useRecipePhysioDemo(val)
    },
    /**
    * 使用中药模板
    */
    async useRecipeDrugDemo(obj) {
      let spu = [];
      obj.recipeTemplateDrugs.forEach(item => { spu.push({spuId:item.spuId,type:item.firstCategory}) });
      let recipeDrugItem = [];
      // 通过kinId查询商品库存以及禁用标识
      let { data } = await Outpatient.getInventory({ spu, deptId: this.$session.get('deptId'), recipeType: '1' })
      obj.recipeTemplateDrugs.forEach(kid => {
        if (isNull(kid.spuId) || kid.spuId < 0) {
          recipeDrugItem.push({ ...kid, id: kid.spuId })
        }
        data.forEach(item => {
          if (item.spuId == kid.spuId) {
            recipeDrugItem.push({ ...kid, ...item,isOwned:'0',itemId:kid.spuId,itemName:item.spuCommonName,itemNum:kid.number,itemUnit:item.unit })
          }
        })
      })
      // 计算处方价格和重量
      let totalPrice = 0,
        weight = 0;
      recipeDrugItem.forEach(item => {
        item.oldDrugName = item.drugName
        totalPrice = this.$bigNumber(totalPrice, '+', this.$bigNumber(item.price, '*', item.number));
        weight = this.$bigNumber(weight, '+', item.number);
      });
      // recipeDrugItem = Common.nameChange(recipeDrugItem, 1)
      let temObj = {
        orderId: this.dialogObj.orderId,
        recipeSourceType: '2',
        projectType: '0',//0处方项目
        recipeType: 1,//中药处方
        doseNum: obj.doseNum,
        doseType: obj.doseType,//颗粒，饮片，全部
        recipeMethod: obj.recipeMethod,//煎法
        recipeMoment: obj.recipeMoment,//服用时机
        frequency: obj.frequency,
        takingDosage: obj.takingDosage,
        takingDays: obj.takingDays,
        applicationTime: obj.applicationTime,
        wrapTime: obj.wrapTime,
        remark: obj.remark,
        isYlcp: '0',
        bakingPowderDosage: obj.bakingPowderDosage,
        creamDosage: obj.creamDosage,
        pelletizingDosage: obj.pelletizingDosage,
        doseFrequency: doseOptions.includes(obj.doseFrequency) ? obj.doseFrequency : '',
        mixingBagNum: obj.mixingBagNum,//冲服
        weight: 0,//药品总重
        processFlag: '0',//是否加工
        process: {//加工信息
          processName: '',
          processPrice: '',
          bagNum: '',
          remark: '',
          processingValue: "[]",
        },
        items: recipeDrugItem
      }
      this.recipesList.push(temObj)
      // Outpatient.editPrescription(temObj).then(res => {
      //     if (!temObj.orderCaseProjectRecipeId) {
      //         temObj.orderCaseProjectRecipeId = res.data;
      //         this.recipeList.push(temObj)
      //     }

      // })
      // 中药处方赋值
      this.templateShow = false;
      this.computeRecipesTotal()
      this.$message.success('使用模版成功');
    },
    /**
   * 使用理疗模板
   */
    async useRecipePhysioDemo(obj) {
      let physioDetail = obj
      let physioItem = physioDetail && physioDetail.recipeTemplateDrugs || [];
      let spu = [];
      physioItem && physioItem.forEach(v=>{ spu.push({spuId:v.spuId })})
      let { data } =await Outpatient.getInventory({doctorId:this.dialogObj.doctorInfo.doctorId, spu, deptId: this.$session.get('deptId'), recipeType: '3' })
        data && data.forEach(v1=>{
          physioItem.forEach(v2=>{
            if(v1.spuId === v2.spuId){
              v2.enableStatus = v1.enableStatus
              if(isNull(v2.physioExtendJson)){
                v2.physioExtendJson = {
                  perUnit: v1.perUnit,
                  perUnitCount: v1.perUnitCount,
                  executionMode: v1.executionMode,
                  soldNum:1,
                  onlyNum:v1.executionMode == 20 ? 3 : null,
                  physioIntervalEnum:null,
                  acupointinfoList:[]
                }
              }
              v2.enableStatus = v1.enableStatus
              v2.price = v1.price
              v2.itemName = v1.spuCommonName
              v2.itemUnit = v1.unit
              v2.itemId = v1.spuId
              if(v1.executionMode == 10){
                v2.physioExtendJson.onlyNum = ''
              }else{
                v2.physioExtendJson.onlyNum = isNull(v2.onlyNum) ? 3 : v2.onlyNum
              }
              v2.physioExtendJson.soldNum = v2.soldNum
              v2.itemNum = v1.executionMode == 20 ? this.$bigNumber(isNull(v2.onlyNum) ? 3 : v2.onlyNum, '*', v2.soldNum) : v2.soldNum
              v2.physioExtendJson.perUnit = v1.perUnit
              v2.physioExtendJson.perUnitCount = v1.perUnitCount
              v2.physioExtendJson.executionMode = v1.executionMode
              v2.physioExtendJson.acupointinfoList = v2.acupointinfoList
              v2.physioExtendJson.physioIntervalEnum = v2.physioIntervalEnum
              v2.effectDrugPriceConfig = v1.effectDrugPriceConfig
              if(v1.effectDrugPriceConfig && v1.effectDrugPriceConfig.configType == 1){
                v2.price = v1.effectDrugPriceConfig.fixedPrice
              }else if(v1.effectDrugPriceConfig && v1.effectDrugPriceConfig.configType == 2){
                let config = this.findPriceRange(v2.itemNum,v1.effectDrugPriceConfig.ladderPriceConfigs)
                v2.price = isNull(config) ? v2.price : config.ladderPrice
              }
            }
          })
        })
        this.recipesList.push({
          isYlcp: obj.isYlcp,
          recipeSourceType: '2',
          orderId: this.dialogObj.orderId,
          projectType: '0',
          recipeType: '3',
          totalPrice: 0,
          items: physioItem,
        });
        this.templateShow = false;
        this.computeRecipesTotal()
        this.$message.success("使用理疗处方模板成功！");
    },
    /**
     * 中药改变
     * val 选择的id obj每项处方 kid每个药品
     */
    drugChange(val, obj, index, objIndex, itemObj) {
      this.hasChildWithClassName()
      if (isNull(val)) return
      let goodsItem = obj.items
      let selectName = ''
      selectName = this.goodsOption.find(item => { return item.itemId == val }).itemName
      let itemIndex = goodsItem.findIndex(item => { return item.itemId == val  || item.itemName == selectName })
      if (Utils.gt(itemIndex, -1)) {
        this.$message.error('您已添加过该商品')
        this.recipesList[index].items[objIndex].itemName = ''
        this.recipesList[index].items[objIndex].itemId = ''
        this.recipesList[index].items[objIndex].spuId = ''
        return
      }
      let goodIndex = this.goodsOption.findIndex(item => { return item.itemId == val })
      let item = this.goodsOption[goodIndex]
      this.recipesList[index].items[objIndex] = { ...item,itemId:item.spuId, itemNum: isNull(itemObj.itemNum) ? 1 : itemObj.itemNum, totalPrice: item.price, remark: '', isShow: true }
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$refs[`${index}num${val}`] && this.$refs[`${index}num${val}`][0].$children[0].focus()
        this.$refs[`${index}num${val}`] && this.$refs[`${index}num${val}`][0].$children[0].select()
        this.selectEffect(index, objIndex)
      })
    },
    /**
     * 理疗改变
     * val 选择的id obj每项处方 kid每个药品
     */
    physioChange(val, obj, index, objIndex) {
      if (isNull(val)) return
      let goodsItem = obj.items
      let itemIndex = goodsItem.findIndex(item => { return item.itemId == val })
      if (Utils.gt(itemIndex, -1)) {
        this.$message.error('您已添加过该商品')
        this.recipesList[index].items[objIndex] = {}
        return
      }
      let goodIndex = this.physioOption.findIndex(item => { return item.itemId == val })
      let item = this.physioOption[goodIndex]
      item.itemNum = item.executionMode == 20 ? this.$bigNumber(3, '*', 1) : 1
      if(item.effectDrugPriceConfig && item.effectDrugPriceConfig.configType == 1){
        item.price = item.effectDrugPriceConfig.fixedPrice
      }else if(item.effectDrugPriceConfig && item.effectDrugPriceConfig.configType == 2){
        let config = this.findPriceRange(item.itemNum,item.effectDrugPriceConfig.ladderPriceConfigs)
        item.price = isNull(config) ? item.price : config.ladderPrice
      }
      let physioExtendJson = {}
      physioExtendJson.perUnit = item.perUnit
      physioExtendJson.perUnitCount = item.perUnitCount
      physioExtendJson.executionMode = item.executionMode
      physioExtendJson.soldNum = 1
      physioExtendJson.onlyNum = item.executionMode == 20 ? 3 : null
      physioExtendJson.physioIntervalEnum = null
      physioExtendJson.acupointinfoList = []
      this.recipesList[index].items[objIndex] = { 
        ...item,physioExtendJson:physioExtendJson,
        executeCount:null,executeInterval:null,executeDesc:null,
       }
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$refs[`search${index}${objIndex}`][0].focus()
      })
    },
    /**
     * 中成药改变
     * val 选择的id obj每项处方 kid每个药品
     */
    async chineseMedicineChange(val, obj, index, objIndex) {
      if (isNull(val)) return
      let goodsItem = obj.items
      let itemIndex = goodsItem.findIndex(item => { return item.itemId == val })
      if (Utils.gt(itemIndex, -1)) {
        this.$message.error('您已添加过该商品')
        this.recipesList[index].items[objIndex] = {}
        return
      }
      let goodIndex = this.chineseMedicineOption.findIndex(item => { return item.itemId == val })
      let item = this.chineseMedicineOption[goodIndex]
      let {code,data} = await getOftenDecoction({spuId: val})
      let newItem = null
      if(code == 200 && data){
       newItem = { 
          ...item, 
          itemNum: 1, 
          totalPrice: item.price, 
          remark: '', 
          useFrequency: data.useFrequency, 
          singleDose: data.singleDose,
          singleDoseUnit:data.singleDoseUnit,
          takingTime:data.takingTime,
          intervalRequirement:data.intervalRequirement,
        }
      }else{
        newItem = { 
          ...item, 
          itemNum: 1, 
          totalPrice: item.price, 
          remark: '', 
          useFrequency: '106', 
          singleDose: '',
          singleDoseUnit:'',
          takingTime:'117',
          intervalRequirement:'',
        }
      }
      // this.$forceUpdate()
      this.$set(this.recipesList[index].items, objIndex, newItem)
      this.$nextTick(() => {
        this.$refs[`${index}num${val}`][0].$children[0].focus()
        this.$refs[`${index}num${val}`][0].$children[0].select()
      })
    },
    /**
     * 非处方项目改变
     * val 选择的id obj每项处方 kid每个药品
     */
    otherChange(val, obj, index, objIndex) {
      if (isNull(val)) return
      let goodsItem = obj.items
      let itemIndex = goodsItem.findIndex(item => { return item.itemId == val })
      if (Utils.gt(itemIndex, -1)) {
        this.$message.error('您已添加过该商品')
        this.recipesList[index].items[objIndex] = {}
        return
      }
      let goodIndex = this.otherOption.findIndex(item => { return item.itemId == val })
      let item = this.otherOption[goodIndex]
      this.recipesList[index].items[objIndex] = { ...item, itemNum: 1, totalPrice: item.price, remark: '' }
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$refs[`${index}num${val}`][0].$children[0].focus()
        this.$refs[`${index}num${val}`][0].$children[0].select()
      })
    },
    /**
    * 处理drugItem数据
    * 
    */
    handDrugs(item, index, isClean = false) {
      let drug = _.cloneDeep(item);
      let druginfo = _.cloneDeep(this.recipesList)
      if (isClean) {
        drug = this.matchOftenUsageList(drug.recipeMethod, drug)
      }
      let obj = {
        ...drug,
      }
      druginfo[index] = obj
      this.$set(this, 'recipesList', druginfo)
      this.$forceUpdate()
    },
    /**
     * 使用医联产品
     */
    async comboInfoBack(comboInfo) {
      let spu = [];
      comboInfo.items.forEach(item => { spu.push({spuId:item.spuId,type:item.firstCategory}) });
      let recipeDrugItem = [];
      // 通过kinId查询商品库存以及禁用标识
      let { data } = await Outpatient.getInventory({ spu, deptId: this.$session.get('deptId'), recipeType: '1' })
      comboInfo.items.forEach(kid => {
        if (isNull(kid.spuId) || kid.spuId < 0) {
          recipeDrugItem.push({ ...kid, onSale: 0,  id: kid.spuId })
        }
        data.forEach(item => {
          if (item.spuId == kid.spuId) {
            recipeDrugItem.push({ ...kid, ...item,isOwned:'0',itemId:kid.spuId,itemName:item.spuCommonName,itemNum:kid.number,itemUnit:item.unit })
          }
        })
      })
      console.log(recipeDrugItem,9999);
      
      // 计算处方价格和重量
      let totalPrice = 0,
        weight = 0;
      recipeDrugItem.forEach(item => {
        item.oldDrugName = item.drugName
        totalPrice = this.$bigNumber(totalPrice, '+', this.$bigNumber(item.price, '*', item.number));
        weight = this.$bigNumber(weight, '+', item.number);
      });
      let temObj = {
        recipeName: comboInfo.comboName,
        orderId: this.dialogObj.orderId,
        sourceRecipeId: comboInfo.comboId,
        recipeSourceType: '2',
        projectType: '0',//0处方项目
        recipeType: '1',//中药处方
        doseNum: comboInfo.quantity,
        doseType: comboInfo.drugForm,//颗粒，饮片，全部
        recipeMethod: '煎服',//煎法
        recipeMoment: '',//服用时机
        frequency: '',
        takingDosage: '',
        takingDays: '',
        applicationTime: '',
        wrapTime: '',
        isYlcp: '1',
        bakingPowderDosage: '',
        creamDosage: '',
        pelletizingDosage: '',
        doseFrequency: '',
        mixingBagNum: '',//冲服
        weight: weight,//药品总重
        totalPrice: totalPrice,
        processFlag: '1',//是否加工
        process: {//加工信息
          processName: '加工-YL',
          processPrice: comboInfo.processFee,
          bagNum: '',
          remark: '',
          processingValue: "[\"加工-YL\"]",
        },
        items: recipeDrugItem
      }
      temObj = this.matchOftenUsageList(temObj.recipeMethod, temObj)
      this.recipesList.push(temObj)
      this.comboShow = false;
      this.$message.success('使用医联产品成功');
    },
    /**
     * 搜索框聚集
     */
    searchFocus() {
      this.goodsOption = []
      this.hasChildWithClassName()
    },
    /**
     * 商品选择效果
     */
    selectEffect(index, itemIndex) {
      this.$refs[`pro-item${index}${itemIndex}`][0].classList.add('pro-item-active')
    },
    /**
     * 移除所有选中效果
     */
    hasChildWithClassName() {
      let parentNode = this.$refs.rightMain
      let className = 'pro-item-active'
      // 使用querySelectorAll获取所有具有指定类名的子元素
      const childrenWithClassName = parentNode.querySelectorAll(`.${className}`);
      // 如果找到至少一个具有指定类名的子元素，则删除其类名
      if (childrenWithClassName.length > 0) {
        childrenWithClassName.forEach(item => {
          item.classList.remove(className)
        })
      }
    },

    //是否自备
    handleIsOwned(index, drugIndex) {
      let drugItem = deepClone(this.recipesList)
      let kid = drugItem[index].items[drugIndex]
      if (isNull(kid.isOwned) || kid.isOwned == '0') {
        kid.isOwned = '1'
        this.isOwnedTip = `note+ ${index} + ${drugIndex}`
        setTimeout(() => {
          this.isOwnedTip = '';//是否添加过
        }, 2000)
      } else if (!isNull(kid.isOwned) && kid.isOwned == '1') {
        kid.isOwned = '0'
      }
      this.$set(this, 'recipesList', drugItem)
      this.computeRecipesTotal()
    },
    // 服用量获取焦点
    mixingBagNumFocus(index) {
      this.$refs[`mixingBagNum_${index}`][0].focus()
    },
    // 服用量失焦数字化处理
    mixingBagNumBlur(e) {
      if (![null, ''].includes(e.target.value)) {
        e.target.value = Number(e.target.value).toString()
      }
    },
    // 匹配常用用法
    matchOftenUsageList(key = '煎服', item) {
      let matchKey = key
      const obj = JSON.parse(JSON.stringify(item))

      doseCanChooseKeys.forEach(key => {
        obj[key] = ''
      })

      if (this.doseCanChoose.findIndex(v => v.name === matchKey) === -1) {
        matchKey = '煎服'
      }
      let defaultOftenUsageOption = this.doseCanChoose.find(v => v.name === matchKey) || { label: [] }
      defaultOftenUsageOption.label.forEach((v) => {
        obj[v.id] = v.default
      })
      const defaultOftenUsageKeys = defaultOftenUsageOption.label.map(v => v.id)

      const remoteOftenUsageOption = this.drugOftenUsageList.find(v => v.recipeMethod === key)
      if (remoteOftenUsageOption) {
        Object.keys(remoteOftenUsageOption).forEach(k => {
          if (defaultOftenUsageKeys.includes(k)) {
            obj[k] = remoteOftenUsageOption[k]
          }
        })
      }

      return obj
    },
    //本地上传图片
    localUpload() {
      this.$nextTick(() => {
        this.$refs.uploadImage.$el.querySelector('input').click()
      })
    },
    //图片处理模块 开始
    handleImgSuccess(data) {
      this.uploading = true
      let arr = []
      arr[0] = { uploadChannel: "postImg", fileId: data, groupName: "group1", isNeedThumbnail: "2" }
      uploadTemporaryFile(arr).then(uploadRes => {
        this.uploading = false
        this.uploadShow = false
        if (uploadRes.errorCode == '0000') {
          this.imgLsit.push(uploadRes.data[0].fullPathUrl)
          this.saveUploadImg()
          this.url = uploadRes.data[0].fullPathUrl;
        } else {
          this.$message.error('上传失败')
        }
      }).catch(err => {
        this.uploading = false;
        this.$message.error('上传失败')
      })
    },
    //保存上传图片
    saveUploadImg() {
      return new Promise(async (resolve, reject) => {
        let { code } = await prescriptionDTO.savePrecreiptionImg({ orderId: this.dialogObj.orderId, images: this.imgLsit.join(',') })
        resolve(code == 200 ? true : false)
      })
    },
    //切换图片
    handleSwitch(type) {
      let index = this.imgLsit.findIndex(i => { return i == this.url })
      if (index == -1) return;
      if (type == 'left') {
        index = index == 0 ? 0 : index - 1
      } else if (type == 'right') {
        index = index == this.imgLsit.length - 1 ? this.imgLsit.length - 1 : index + 1;
      }
      this.url = this.imgLsit[index]
    },
    //删除处方
    handleDelImg() {
      let index = this.imgLsit.findIndex(i => { return i == this.url })
      if (index > -1) {
        this.imgLsit.splice(index, 1)
        this.url = this.imgLsit.length > 0 ? this.imgLsit[this.imgLsit.length - 1] : ''
        this.saveUploadImg()
      }
    },
    //获取处方图片
    async getPrecreiptionImg() {
      let { code, data } = await prescriptionDTO.getPrecreiptionImg({ orderId: this.dialogObj.orderId })
      if (code == 200) {
        this.imgLsit = isNull(data.images) ? [] : data.images.split(',')
        this.url = this.imgLsit[0]
      }
    },
    //是否开始上传
    isUpload(loading) {
      this.uploadShow = false;
      this.uploading = loading
    },
    //手机完成上传
    uploadCompany() {
      this.uploadShow = false
      this.getPrecreiptionImg()
    },
    getAcupointsList(acupointName) {
      acupointList({ acupointName, speciesType:'' }).then(res => {
        let { code, rows } = res
        if (code == 200) {
          this.acupointOptions = rows;
        }
      })
    },
    //获取理疗执行周期
    async getPhysioIntervalEnum() {
      getPhysioIntervalEnum().then(res => {
        if (res.code == 200) {
          this.physioIntervalEnum = res.data || []
          let list = []
          res.data.forEach(v => {
            list.push({
              label: v.executeDesc,
              value: v.executeDesc
            })
          })
          this.physioIntervalEnumOption = list
        }
      })
    },
    changeAcupointType(val, acupoint,index,itemIndex,acupointIndex) {
      if(acupoint.type != 10 && acupoint.type != 60 && acupoint.type != 50 && val == 10){ return}
      if(acupoint.type == 50){
        acupoint.typeExtend = [`${val}`]
      }else{
        acupoint.type = val
      }
      this.$forceUpdate()
      this.$refs[`popover${index}${itemIndex}${acupointIndex}`][0].doClose()
    },
    //选择穴位或部位
    selectAcupointName(val, obj,index,itemIndex) {
      let acupointinfoList = obj.physioExtendJson.acupointinfoList || []
      let acupointIndex = acupointinfoList.findIndex(v => {
        return v.acupointId == val
      })
      if (acupointIndex > -1) {
        this.alreadyAdd = `note${index}${itemIndex}`
        this.acupointName = ''
        setTimeout(() => {
          this.alreadyAdd = '';//是否添加过
        }, 2000)
        return;
      }
      let acupoint = this.acupointOptions.find(v => { return v.acupointId == val })
      if(acupoint.type == 50){
        acupoint.typeExtend = ['1']
      }else if(acupoint.type == 60){
        acupoint.typeExtend = ['1-1','1-2','1-3','1-4','2-1','2-2','2-3','2-4']
      }
      obj.physioExtendJson.acupointinfoList.push(acupoint)
      if(obj.physioExtendJson.perUnit && obj.physioExtendJson.perUnit != acupoint.speciesType){
        this.speciesTypeTips = `note${index}${itemIndex}${obj.physioExtendJson.acupointinfoList.length-1}`
        setTimeout(() => {
          this.speciesTypeTips = '';
        }, 2000)
      }
      this.$nextTick(()=>{
        this.$refs[`search${index}${itemIndex}`][0].blur()
        this.$refs[`search${index}${itemIndex}`][0].focus()
      })
      this.acupointName = ''
      this.acupointOptions = []
    },
    changeAcupoint(val, index, itemIndex, acupointIndex) {
      let physioItem = this.recipesList
      let item = physioItem[index].items[itemIndex]
      let aIndex = item.physioExtendJson.acupointinfoList.findIndex(v => {
        return v.acupointId == val
      })
      if (aIndex > -1) {
        this.alreadyAdd = `note${index}${itemIndex}${acupointIndex}`
        item.physioExtendJson.acupointinfoList[acupointIndex].acupointName = ''
        this.acupointOptions = []
        setTimeout(() => {
          this.alreadyAdd = '';//是否添加过
          item.physioExtendJson.acupointinfoList[acupointIndex] = this.focusAcupoint
        }, 2000)
        return;
      }
      let acupointObj = this.acupointOptions.find(v => { return v.acupointId == val })
      if(acupointObj.type == 50){
        acupointObj.typeExtend = ['1']
      }else if(acupointObj.type == 60){
        acupointObj.typeExtend = ['1-1','1-2','1-3','1-4','2-1','2-2','2-3','2-4']
      }
      item.physioExtendJson.acupointinfoList[acupointIndex] = acupointObj
      if(item.physioExtendJson.perUnit && item.physioExtendJson.perUnit != acupointObj.speciesType){
        this.speciesTypeTips = `note${index}${itemIndex}${acupointIndex}`
        setTimeout(() => {
          this.speciesTypeTips = '';
        }, 2000)
      }
      this.acupointName = ''
      this.acupointOptions = []
      this.$nextTick(()=>{
        this.$refs[`search${index}${itemIndex}`][0].blur()
        this.$refs[`search${index}${itemIndex}`][0].focus()
      })
    },
    deleteAcupoint(index, itemIndex, acupointIndex) {
      let physioItem = this.recipesList
      let item = physioItem[index].items[itemIndex]
      item.physioExtendJson.acupointinfoList.splice(acupointIndex, 1)
    },
    openAcupoint(index, itemIndex) {
      let list = this.recipesList[index].items[itemIndex].physioExtendJson.acupointinfoList
      this.chooseList = deepClone(list)
      this.acupointDialogObj.index = index
      this.acupointDialogObj.physioIndex = itemIndex
      this.acupointDialogObj.tabIndex = ( !isNull( this.recipesList[index].items[itemIndex].physioExtendJson.perUnit) &&  this.recipesList[index].items[itemIndex].physioExtendJson.perUnit) == 20 ? 2 : 0
      this.acupointDialogShow = true
    },
    accupointConfirm(obj) {
      let { index, physioIndex, chooseList } = obj
      chooseList.forEach(v=>{
        if(v.type == 50){
          v.typeExtend = isNull(v.typeExtend) ? ['1'] : v.typeExtend
        }else if(v.type == 60){
          v.typeExtend = isNull(v.typeExtend) ? ['1-1','1-2','1-3','1-4','2-1','2-2','2-3','2-4'] : v.typeExtend
        }
      })
      let item = this.recipesList[index].items[physioIndex]
      item.physioExtendJson.acupointinfoList = chooseList
      this.acupointDialogShow = false
    },
    acupointDialogClose() {
      this.acupointDialogShow = false
    },
    soldNumChange(val, index, itemIndex) {
      let item = this.recipesList[index].items[itemIndex]
      item.physioExtendJson.soldNum = item.physioExtendJson.soldNum.replace(/^(0+)|[^\d]+/g, '')
      item.itemNum = item.physioExtendJson.executionMode == 20 ? this.$bigNumber(item.physioExtendJson.onlyNum, '*', val) : item.physioExtendJson.soldNum
      let config = this.findPriceRange(item.itemNum,item.effectDrugPriceConfig.ladderPriceConfigs)
      if(item.effectDrugPriceConfig.configType == 2 && !isNull(config)){
        item.price = config.ladderPrice
      }
      this.computeRecipesTotal()
    },
    onlyNumChange(val, index, itemIndex) {
      let item = this.recipesList[index].items[itemIndex]
      item.physioExtendJson.onlyNum = item.physioExtendJson.onlyNum.replace(/^(0+)|[^\d]+/g, '')
      item.itemNum = this.$bigNumber(item.physioExtendJson.soldNum, '*', val)
      let config = this.findPriceRange(item.itemNum,item.effectDrugPriceConfig.ladderPriceConfigs)
      if(item.effectDrugPriceConfig.configType == 2 && !isNull(config)){
        item.price = config.ladderPrice
      }
      this.computeRecipesTotal()
    },
    physioIntervalEnumChange(val, obj) {
      if(isNull(val)){ 
        obj.executeCount=null
        obj.executeInterval=null
        obj.executeDesc=null
        obj.physioExtendJson.physioIntervalEnum=null
      }else{
        let physioIntervalEnum = this.physioIntervalEnum.find(v => { return v.executeDesc === val })
        obj.executeCount = physioIntervalEnum.executeCount
        obj.executeInterval = physioIntervalEnum.executeInterval
        obj.executeDesc = physioIntervalEnum.executeDesc
        obj.physioExtendJson.physioIntervalEnum = physioIntervalEnum.key
      }
      this.$forceUpdate()
    },
    clickOnlyNum(index,itemIndex){
      this.$nextTick(()=>{
        this.$refs[`frequencyInput${index}${itemIndex}`][0].select()
      })
    },

    
    /**
     * 复诊
     */
    // 选择复诊时间
    changeRepeatVisitDateHandle() {
      if (this.repeatVisitInfo.dateVal !== '') {
        this.repeatVisitInfo.revisitFlag = '1'
      }
    },

    // 选择复诊/无需复诊checkbox
    changeRepeatVisitHandle(e,value) {
      if(e === false){
        this.repeatVisitInfo.revisitFlag = value
      }else{
        this.repeatVisitInfo.revisitFlag = e
      }
      if (['0','2'].includes(e)) {
        this.repeatVisitInfo.dateVal = ''
      }
    },

    // 匹配remark
    inputRemarkHandle: debounce(function() {
      this.searchRemarkHandle()
    }, 300),

    // 匹配remark
    searchRemarkHandle() {
      const remarkResultList = this.repeatVisitInfo.remarkInfo.remarkList.filter(item => item.includes(this.repeatVisitInfo.remarkInfo.remark))
      this.repeatVisitInfo.remarkInfo.showRemark = remarkResultList.length > 0
      this.repeatVisitInfo.remarkInfo.remarkResultList = remarkResultList
    },

    // 选择复诊备注
    setRemarkHandle(str = '') {
      this.repeatVisitInfo.remarkInfo.remark = str
      this.repeatVisitInfo.remarkInfo.showRemark = false
    },
    findPriceRange(val, configs) {
      for (let i = 0; i < configs.length; i++) {
        const config = configs[i];
        const ladderStartNumber = config.ladderStartNumber;
        const ladderEndNumber = config.ladderEndNumber;
        // 处理max为空字符串的情况（表示无上限）
        if (isNull(ladderEndNumber)) {
          if (val >= ladderStartNumber) {
            return config;
          }
        } 
        // 正常区间判断
        else {
          if (val >= ladderStartNumber && val <= ladderEndNumber) {
            return config;
          }
        }
      }
      // 没有找到匹配的区间
      return null;
    },
    physioRemarkInput(item) {
      item.remark = item.remark.replace(/[\n]+/g, '')
    },
    physioRemarkBlur(item) {
      if (item.remark && item.remark.trim() == '') {
        item.remark = null
      }
    },
    findPriceRange(val, configs) {
      for (let i = 0; i < configs.length; i++) {
        const config = configs[i];
        const ladderStartNumber = config.ladderStartNumber;
        const ladderEndNumber = config.ladderEndNumber;
        // 处理max为空字符串的情况（表示无上限）
        if (isNull(ladderEndNumber)) {
          if (val >= ladderStartNumber) {
            return config;
          }
        } 
        // 正常区间判断
        else {
          if (val >= ladderStartNumber && val <= ladderEndNumber) {
            return config;
          }
        }
      }
      // 没有找到匹配的区间
      return null;
    },
    useIngredient(obj){
      let { ingredientsTemplateDetails,drugItemIndex} = obj
      let recipesList = deepClone(this.recipesList)
      recipesList[drugItemIndex].ingredients = ingredientsTemplateDetails
      this.$set(this, 'recipesList', recipesList)
      this.$refs.addIngredient.handleClose()
      console.log(this.recipesList,99999);
      
    },
    openIngredient(index){
      if(isNull(this.recipesList[index].ingredients) || isEmptyArray(this.recipesList[index].ingredients)){
        this.$refs.addIngredient.open({index,ingredient:null,type:'add'})
      }else{
        let recipesList = deepClone(this.recipesList)
        recipesList[index].ingredients = null
        this.$set(this, 'recipesList', recipesList)
      }
    },
    editIngredient(index){
      let ingredient = deepClone(this.recipesList[index].ingredients)
      this.$refs.addIngredient.open({index,ingredient,type:'editIngredient'})
    },
    openComboSelect () {
      this.$refs.comboSelect.open()
    },
    submitComboSelect (info) {
      const hasActivity = this.actList.some(v => v.actNumber === info.number)
      if (hasActivity) {
        this.$message.error('套餐已添加')
        return
      }
      const physioList = info.physios.filter(v => {
        v['drugType'] = 1
        v['itemName'] = v.drugName
        v['spuCommonName'] = v.drugName
        v['itemUnit'] = v.unit
        v['executeCount'] = null
        v['executeDesc'] = null
        v['executeInterval'] = null
        v['physioExtendJson'] = {
          acupointinfoList: [],
          executionMode: v.executionMode,
          onlyNum: v.groupCount,
          perUnit: v.perUnit,
          perUnitCount: v.perUnitCount,
          physioIntervalEnum: null,
          soldNum: v.executionMode === 20 ? v.itemNum * v.groupCount : v.itemNum
        }
        return v.itemNum > 0
      })
      const drugList = info.drugs.filter(v => {
        v['drugType'] = 2
        v['itemName'] = v.drugName
        v['spuCommonName'] = v.drugName
        v['itemUnit'] = v.unit
        v['executeCount'] = null
        v['executeDesc'] = null
        v['executeInterval'] = null
        return v.itemNum > 0
      })
      const activity = {
        actNumber: info.number,
        actCseName: info.cseName,
        actCount: info.count,
        totalPrice: Math.round(info.count * info.price * 100) / 100,
        items: [...physioList, ...drugList]
      }
      this.actList.push(activity)
      this.$refs['comboSelect'].close()
    },
    //获取字典值
    getDictData() {
      getDict('useFrequency').then(res => {
        if (res.code == 200) {
          this.dictData.useFrequency = res.data
        }
      })
      getDict('singleDoseUnit').then(res => {
        if (res.code == 200) {
          this.dictData.singleDoseUnit = res.data
        }
      })
      getDict('takingTime').then(res => {
        if (res.code == 200) {
          this.dictData.takingTime = res.data
        }
      })
      getDict('intervalRequirement').then(res => {
        if (res.code == 200) {
          this.dictData.intervalRequirement = res.data
        }
      })
    },
    singleDoseChange:debounce(function(obj){
      if (!obj.singleDose) {
        obj.singleDose = null
      }
      obj.singleDose = String(obj.singleDose || '').replace(/[^\d.]/g, '').replace(/^(\d*)\.(\d?).*$/, '$1.$2').replace(/^0+([0-9])/, '$1');
      if (parseFloat(obj.singleDose) === 0) {
        obj.singleDose = '';
      }
    }, 500),
  },
}
</script>

<style lang="less" scoped src="./additionalPrescriptionDialog.less"></style>

<style lang="less">
.risk-tooltip{
  background: #FFFDE9 !important;
  color: #000 !important;
  font-size: 14px !important;
  border: none !important;
  .popper__arrow{
    border: none !important;
    &::after{
      border-bottom-color: #FFFDE9 !important;
    }
  }
}
.diagnosePop {
  padding: 0;
}

.usage-popper {
  padding: 0;

  .usage-list {
    background: #FFFFFF;
    box-shadow: 0px 4px 8px 0px rgba(183, 183, 183, 0.25);
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #E1E1E1;

    .usage-item {
      padding: 8px 10px;
      font-size: 15px;
      color: #333;
      cursor: pointer;

      &:hover {
        background: #D4E4FF;
      }
    }
  }
}
.acupoint-popover {
  padding: 0;
  min-width: 120px;
  margin-top: 4px !important;

  .popper__arrow {
    display: none;
  }

  .acupoint-position {
    display: flex;
    border: 1px solid #E0E0E0;
    border-radius: 0px 2px 2px 0px;
    flex-wrap: wrap;
    max-width: 200px;
    .acupoint-position-item {
      width: 40px;
      height: 38px;
      background: #FFFFFF;
      border-right: 1px solid #E0E0E0;
      border-bottom: 1px solid #E0E0E0;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      flex-shrink: 0;
      box-sizing: border-box;
    }

    .acupoint-position-item-active {
      background: #409EFF;
      color: #fff;
    }
    .acupoint-position-item-disabled {
      background: #F7F8F9;
      cursor: not-allowed;
      color: #000 !important;
    }
  }
  .acupoint-SiFen{
    padding: 12px;
    width: 304px;
    box-sizing: border-box;
    .el-checkbox{
      margin-right: 16px;
      .el-checkbox__label{
        padding-left: 3px;
      }
      &:last-child{
        margin-right: 0;
      }
    }
  }
}

.activity_section {
  margin: 12px 0 0 0;
  width: 100%;
}
</style>
